if (['16093135176067', '16379882635651'].indexOf(String((window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.id) || '')) > -1 && window.matchMedia && window.matchMedia('(max-width: 749px)').matches) window.pplrStickyLive = false;
/* Aquarell motifs (Oct 2026): tab order + default background per motif. Used by all motif tab blocks below. */
window.BZ_AQ_ORDER = ["Aquarell-Loewe","Aquarell-Schmetterling","Aquarell-Meerjungfrau","Aquarell-Katze","Aquarell-Tiger","Aquarell-Fuchs","Aquarell-Einhorn","Aquarell-Dino","Aquarell-Hase","Aquarell-Eule","Aquarell-Panda","Aquarell-Schildkroete","Aquarell-Biene","Aquarell-Igel","Aquarell-Koala","Aquarell-Giraffe","Aquarell-Delfin","Aquarell-Elefant","Aquarell-Pinguin","Aquarell-Pony","Aquarell-Marienkaefer","Aquarell-Hund","Aquarell-Baer","Rentier-Wn-2","Baer-Wn-2"];
window.BZ_AQ_COLOR = {
  "Aquarell-Loewe": "Taubenblau", "Aquarell-Schmetterling": "Salbeigrün", "Aquarell-Meerjungfrau": "Lila",
  "Aquarell-Katze": "Taubenblau", "Aquarell-Tiger": "Taubenblau", "Aquarell-Fuchs": "Taubenblau",
  "Aquarell-Einhorn": "Lila", "Aquarell-Dino": "Buttergelb", "Aquarell-Hase": "Salbeigrün",
  "Aquarell-Eule": "Taubenblau", "Aquarell-Panda": "Salbeigrün", "Aquarell-Schildkroete": "Taubenblau",
  "Aquarell-Biene": "Taubenblau", "Aquarell-Igel": "Salbeigrün", "Aquarell-Koala": "Terrakotta",
  "Aquarell-Giraffe": "Taubenblau", "Aquarell-Delfin": "Sandbeige", "Aquarell-Elefant": "Buttergelb",
  "Aquarell-Pinguin": "Taubenblau", "Aquarell-Pony": "Lila", "Aquarell-Marienkaefer": "Salbeigrün",
  "Aquarell-Hund": "Taubenblau", "Aquarell-Baer": "Salbeigrün",
  "Rentier-Wn-2": "Taubenblau", "Baer-Wn-2": "Taubenblau"
};
/* ============================================================
   BUNTIFY – speed helpers (Oct 2026)
   1) window.bzThumb(url, width): small copy of a Zepto image.
      Shopify-hosted images are resized by Shopify's CDN (?width=).
      Zepto-hosted images (cdn-zeptoapps.com) have a copy in Shopify Files named
      "bz-preset-<file name>"; callers fall back to the original if a copy is missing.
   2) Every MutationObserver in this file runs its callback at most once per frame
      (records are collected). Before, each DOM change anywhere on the page ran ~20 callbacks
      immediately, which made the page slow while Zepto/Judge.me were building.
      (Oct 29) The batched callbacks now run right AFTER the next paint, so a tap's response
      (INP) no longer waits for them.
   3) (Oct 28) Product gate: blocks written for one product only run on that product's page.
      The preview height and the size arrows no longer force a layout after every DOM change.
   ============================================================ */
window.bzThumb = window.bzThumb || function (url, w) {
  if (!url) return url;
  var clean = String(url).split('?')[0];
  if (clean.indexOf('cdn.shopify.com/s/files/') > -1 || clean.indexOf('/cdn/shop/files/') > -1) return clean + '?width=' + w;
  var m = clean.match(/cdn-zeptoapps\.com\/product-personalizer\/images\/scmbps-b1\.myshopify\.com\/([^\/]+)$/);
  if (m) return 'https://cdn.shopify.com/s/files/1/1018/5287/3091/files/bz-preset-' + m[1] + '?width=' + w;
  return url;
};
/* Current product id (Shopify sets this before theme scripts run).
   null = not a product page -> every block runs as before. */
window.BZ_PID = window.BZ_PID || (function () {
  try {
    var p = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    if (p && p.id) return String(p.id);
    if (window.meta && window.meta.product && window.meta.product.id) return String(window.meta.product.id);
  } catch (e) {}
  return null;
})();
window.bzOn = function (id) { return !window.BZ_PID || window.BZ_PID === String(id); };
(function (MutationObserver) {
/* Zepto 9.648 fix (Android double cart line).
   pplr_final_print() re-arms itself with setTimeout(pplr_final_print, 500) while it has no preview URL
   (template mode createproduct=3). When the first /cart/add.js succeeds, Zepto's pplr_reset_cart() clears
   its "already running" flag, so the stale timer then runs a second full add before the page has left
   for /cart. Desktop leaves the page fast enough to hide it; Android does not.
   Here: once a Zepto add succeeded, a pplr_final_print call that was NOT caused by a new user action
   is a stale retry and is ignored. Any tap/click/key press re-enables adding. Requests are not filtered. */
(function () {
  var added = false;
  var wrapper = null;

  function markAdded() { added = true; }
  function clearAdded() { added = false; }

  var P = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
  if (P && !P.__bzAddWatch) {
    P.__bzAddWatch = true;
    var origOpen = P.open, origSend = P.send;
    P.open = function (method, url) {
      try { this.__bzUrl = String(url); } catch (e) {}
      return origOpen.apply(this, arguments);
    };
    P.send = function () {
      var xhr = this;
      try {
        if (/\/cart\/add(\.js)?(\?|$)/.test(xhr.__bzUrl || "")) {
          xhr.addEventListener("load", function () {
            if (xhr.status >= 200 && xhr.status < 300) markAdded();
          });
        }
      } catch (e) {}
      return origSend.apply(this, arguments);
    };
  }

  ["pointerdown", "touchstart", "mousedown", "click", "keydown"].forEach(function (type) {
    document.addEventListener(type, clearAdded, true);
  });
  window.addEventListener("pageshow", clearAdded);

  function patch() {
    var f = window.pplr_final_print;
    if (typeof f !== "function" || f === wrapper) return;
    wrapper = function () {
      if (added) {
        try { console.log("[buntify] ignored stale pplr_final_print retry after successful add"); } catch (e) {}
        return;
      }
      return f.apply(this, arguments);
    };
    window.pplr_final_print = wrapper;
  }
  patch();
  window.setInterval(patch, 250); // microseconds per run; keeps the Android fix in place
})();
/* Pause Buntify page tweaks while Zepto adds to the cart.
   Zepto's add routine (pplr_final_print) re-measures/redraws the preview; our observers resizing
   the preview wrapper or floating it at the same moment made it run twice (double cart line). */
(function () {
  function pause() {
    window.__bzAdding = true;
    window.clearTimeout(window.__bzAddingTimer);
    window.__bzAddingTimer = window.setTimeout(function () { window.__bzAdding = false; }, 8000);
  }
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.add-to-cart-button, [id*="ProductSubmitButton"], form[action*="/cart/add"] button[type="submit"]')) pause();
  }, true);
  window.addEventListener("pageshow", function () { window.__bzAdding = false; });
})();
(function() {

  var PRODUCT_CARDS = {

    // Namensaufkleber Story – 3 Optionen
    "16006005096835": {
      "40 Stk.": {
        title: "40 Aufkleber",
        desc:  "Selbstklebend, Größe 3 x 1,3 cm",
        price: "9,99 €",
        oldPrice: "14,99 €",
        badge: null
      },
      "120 Stk.": {
        title: "120 Aufkleber",
        desc:  "Selbstklebend, Größe 3 x 1,3 cm",
        price: "14,99 €",
        oldPrice: "19,99 €",
        badge: "Beste Wahl"
      },
      "160 Stk.": {
        title: "160 Aufkleber",
        desc:  "Selbstklebend, Größe 3 x 1,3 cm",
        price: "19,99 €",
        oldPrice: "24,99 €",
        badge: null
      }
    },

    // Stiftaufkleber Story – 2 Optionen
    "16033512751491": {
      "80 Stk.": {
        title: "80 Aufkleber",
        desc:  "Selbstklebend, Größe 4 x 0,6 cm",
        price: "11,99 €",
        oldPrice: "13,99 €",
        badge: null
      },
      "160 Stk.": {
        title: "120 Aufkleber",
        desc:  "Selbstklebend, Größe 4 x 0,6 cm",
        price: "19,99 €",
        oldPrice: "24,99 €",
        badge: "Beste Wahl"
      }
    },

   // Namensaufkleber – Tier-Design + Hintergrund
"16093135176067": {
  "40 Stk.": {
    title: "40 Aufkleber",
    desc:  "",
    price: "9,99 €",
    oldPrice: "11,99",
    pricePerPiece: "0,25 €/Stk.",
    badge: null
  },
  "80 Stk.": {
    title: "80 Aufkleber",
    desc:  "",
    price: "12,99 €",
    oldPrice: "14,99",
    pricePerPiece: "0,16 €/Stk.",
    badge: null
  },
  "120 Stk.": {
    title: "120 Aufkleber",
    desc:  "",
    price: "16,99 €",
    oldPrice: "19,99",
    pricePerPiece: "0,14 €/Stk.",
    badge: null
  },
  "240 Stk.": {
    title: "240 Aufkleber",
    desc:  "",
    price: "22,99 €",
    oldPrice: "29,99",
    pricePerPiece: "0,09 €/Stk.",
    badge: "Beliebt"
  }
},

    // Stifteaufkleber (neu) – Design + Hintergrund, 2 Optionen
    "16177787339139": {
        "60 Stk.": {
        title: "60 Aufkleber",
        desc:  "Selbstklebend, Größe 4 x 0,6 cm",
        price: "9,99 €",
        oldPrice: "11,99 €",
        badge: null
      },
      "120 Stk.": {
        title: "120 Aufkleber",
        desc:  "Selbstklebend, Größe 4 x 0,6 cm",
        price: "12,99 €",
        oldPrice: "14,99 €",
        badge: null
      },
      "200 Stk.": {
        title: "200 Aufkleber",
        desc:  "Selbstklebend, Größe 4 x 0,6 cm",
        price: "22,99 €",
        oldPrice: "24,99",
        badge: "Beste Wahl"
      }
    },

    // Schulpaket – Produkt auswählen, 2 Sets
    "16224637387139": {
      "Starter-Set": {
        title: "Starter-Set – 132 Stk., 3 Größen",
        details: [
          "80x Stift- & Kleinteile-Aufkleber (4 x 0,6 cm)",
          "40x Namensaufkleber (3 x 1,3 cm)",
          "12x große Aufkleber (5 x 2 cm) "
        ],
        price: "24,99 €",
        oldPrice: "",
        badge: null
      },
      "Großes Set": {
        title: "Großes Set – 236 Stk., 3 Größen",
        details: [
          "120x Stifteaufkleber (4 x 0,6 cm)",
          "80x Namensaufkleber (3 x 1,3 cm)",
          "36x große Aufkleber (5 x 2 cm)"
        ],
        price: "34,99 €",
        oldPrice: "",
        badge: "⭐ Beste Wahl"
      }
    }

  };

  var DEFAULT_SELECTION = {
    "16093135176067": "240 Stk.",
    "16177787339139": "200 Stk."
  };

  var defaultSelectionApplied = false;

  function applyDefaultSelection() {
    if (defaultSelectionApplied) return;
    defaultSelectionApplied = true;

    if (!productId || !DEFAULT_SELECTION[productId]) return;

    var wanted = DEFAULT_SELECTION[productId];
    var items = document.querySelectorAll('.pplr-drop-item[data-enhanced="1"]');
    var target = null;

    for (var i = 0; i < items.length; i++) {
      var raw = (items[i].getAttribute('data-value') || items[i].textContent || '').trim();
      if (raw === wanted) { target = items[i]; break; }
    }

    if (target && !target.classList.contains('active')) {
      target.click();
    }
  }

  var DEFAULT_BASE_PRICE = null;

  function buildFallbackData(item) {
    var raw = (item.getAttribute('data-value') || item.textContent || '').trim();
    var priceOffset = parseFloat(item.getAttribute('data-pplr_price') || '0');

    var priceHTML = null;
    if (DEFAULT_BASE_PRICE !== null) {
      priceHTML = (DEFAULT_BASE_PRICE + priceOffset).toFixed(2).replace('.', ',') + ' €';
    }

    return {
      title: raw,
      desc:  "",
      price: priceHTML,
      oldPrice: null,
      badge: null
    };
  }

  var productId = (window.ShopifyAnalytics &&
                   window.ShopifyAnalytics.meta &&
                   window.ShopifyAnalytics.meta.product &&
                   String(window.ShopifyAnalytics.meta.product.id)) ||
                  (window.meta && window.meta.product && String(window.meta.product.id)) ||
                  (document.querySelector('.product-personalizer[data-id]') &&
                   String(document.querySelector('.product-personalizer[data-id]').getAttribute('data-id'))) ||
                  (document.querySelector('product-form-component[data-product-id]') &&
                   String(document.querySelector('product-form-component[data-product-id]').getAttribute('data-product-id'))) ||
                  null;

  var CARD_DATA = productId && PRODUCT_CARDS[productId] ? PRODUCT_CARDS[productId] : null;
  var USING_FALLBACK = !CARD_DATA;

  /* Same result as before (wrapper height = canvas height), but the height now comes from a
     ResizeObserver instead of reading offsetHeight after every DOM change (forced layout). */
  var bzCanvasH = 0, bzRoCanvas = null, bzRo = null;
  function bzApplyWrapperHeight(canvas) {
    var wrapper = canvas.closest('.pplr_preview_wrapper');
    if (!wrapper || !(bzCanvasH > 0)) return;
    var v = bzCanvasH + 'px';
    if (wrapper.style.height !== v) wrapper.style.height = v;
  }
  function syncPreviewWrapper() {
    if (window.__bzAdding) return; // pause page tweaks while Zepto adds to cart
    var canvas = document.getElementById('pplr_canvas');
    if (!canvas) return;
    if (!window.ResizeObserver) { // very old browsers: previous behaviour
      var wrapper = canvas.closest('.pplr_preview_wrapper');
      var h = canvas.offsetHeight;
      if (wrapper && h > 0) wrapper.style.height = h + 'px';
      return;
    }
    if (canvas !== bzRoCanvas) { // first run, or Zepto replaced the canvas
      if (!bzRo) bzRo = new ResizeObserver(function (entries) {
        var e = entries[entries.length - 1];
        var box = e.borderBoxSize && (e.borderBoxSize[0] || e.borderBoxSize);
        bzCanvasH = Math.round(box && box.blockSize != null ? box.blockSize : e.target.offsetHeight);
        if (bzCanvasH > 0 && !window.__bzAdding) bzApplyWrapperHeight(e.target);
      });
      if (bzRoCanvas) bzRo.unobserve(bzRoCanvas);
      bzRoCanvas = canvas;
      bzRo.observe(canvas); // reports the current size right away
      return;
    }
    bzApplyWrapperHeight(canvas);
  }

  function enhanceCards() {
    var items = document.querySelectorAll('.pplr-drop-item');
    if (!items.length) return;

    items.forEach(function(item) {
      if (item.getAttribute('data-enhanced')) return;

      var preservedNodes = Array.prototype.slice.call(item.children);

      var raw = (item.getAttribute('data-value') || item.textContent || '').trim();
      var data = null;

      if (CARD_DATA) {
        data = CARD_DATA[raw];
        if (!data) {
          item.style.display = 'none';
          item.classList.remove('active');
          return;
        }
      } else {
        data = buildFallbackData(item);
      }

      var ribbonHTML = data.badge
        ? '<div class="pplr-drop-ribbon">' + data.badge + '</div>'
        : '';

      var oldPriceHTML = data.oldPrice
        ? '<span class="pplr-drop-price-old" style="text-decoration:line-through;color:#999;font-size:1.1em;margin-right:6px;">' + data.oldPrice + '</span>'
        : '';

      var descHTML = data.desc
        ? '<span class="pplr-drop-desc">' + data.desc + '</span>'
        : '';

      var detailsHTML = Array.isArray(data.details) && data.details.length
        ? '<ul class="pplr-drop-details">' +
            data.details.map(function(detail) {
              return '<li>' + detail + '</li>';
            }).join('') +
          '</ul>'
        : '';

    var perPieceHTML = data.pricePerPiece
        ? '<span class="pplr-unit-price">' + data.pricePerPiece + '</span>'
        : '';

      var priceHTML = data.price
        ? '<span class="pplr-drop-price-wrap">' +
            oldPriceHTML +
            '<span class="pplr-drop-price" style="font-size:1.3em;font-weight:bold;">' + data.price + '</span>' +
            perPieceHTML +
          '</span>'
        : '';

      item.innerHTML =
        ribbonHTML +
        '<span class="pplr-drop-title">' + data.title + '</span>' +
        descHTML +
        detailsHTML +
        priceHTML;

      preservedNodes.forEach(function(node) {
        item.appendChild(node);
      });

      if (data.badge) {
        item.classList.add('pplr-drop-item--bestseller');
      }

      item.setAttribute('data-enhanced', '1');
    });

    var activeItem = document.querySelector('.pplr-drop-item.active');
    if (!activeItem || activeItem.style.display === 'none') {
      var firstVisible = document.querySelector('.pplr-drop-item[data-enhanced="1"]');
      if (firstVisible) firstVisible.click();
    }

    applyDefaultSelection();

    if (USING_FALLBACK && window.console) {
      console.warn('[Buntify Personalizer] Product ID "' + productId + '" has no PRODUCT_CARDS entry — using generic fallback cards.');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      enhanceCards();
      syncPreviewWrapper();
    });
  } else {
    enhanceCards();
    syncPreviewWrapper();
  }

  var observer = new MutationObserver(function(mutations) {
    if (window.__bzAdding) return; // pause page tweaks while Zepto adds to cart
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) { enhanceCards(); break; }
    }
    syncPreviewWrapper(); // no layout read any more (ResizeObserver provides the height)
  });

  observer.observe(document.body, { childList: true, subtree: true });

})();

/* ============================================================
   BUNTIFY – FLOATING PREVIEW CONTROLLER & STATIC SIZING FIX
   ============================================================ */
/* Sticky live preview: handled by Zepto itself plus the CSS in the personalizer stylesheet.
   The former JS preview controller was removed on purpose: it resized/hid Zepto's preview canvases,
   which made Zepto's add-to-cart routine run twice (double cart line on Android). */

/* ============================================================
   BUNTIFY - SCHULPAKET ACCORDIONS (NO DOM MOVING)
   Product: 16224637387139
   ============================================================ */
(function () {
  "use strict";

  var PRODUCT_ID = "16224637387139";
  if (!window.bzOn(PRODUCT_ID)) return;
  var ROOT_SELECTOR = "#pplr-" + PRODUCT_ID;

var ACCORDIONS = [
  {
    motifSelector: ".pplr-_groe-aufkleber-5-cm-x-2-cm--motiv-auswhlen",
    backgroundSelector: ".pplr-_groe-aufkleber-hintergrund",
    nameSelector: ".pplr-_groe-aufkleber-5-cm-x-2-cm--name-eingeben",
    label: "Große Aufkleber (5 cm x 2 cm)"
  },
  {
    motifSelector: ".pplr-_stifteaufkleber-4-cm-x-06-cm--motiv-auswhlen",
    backgroundSelector: ".pplr-_stifte-aufkleber-hintergrund",
    nameSelector: ".pplr-_stifteaufkleber-4-cm-x-06-cm",
    label: "Stifteaufkleber (4 cm x 0,6 cm)"
  },
  {
    motifSelector: ".pplr-_kleine-aufkleber-3-x-13-cm--motiv-auswhlen",
    backgroundSelector: ".pplr-_kleine-aufkleber-hintergrund",
    nameSelector: ".pplr-_kleine-aufkleber-3-x-13-cm--name-eingeben",
    label: "Kleine Aufkleber (3 x 1,3 cm)"
  }
];

  function findDirectLabel(wrapper) {
    if (!wrapper) return null;

    for (var i = 0; i < wrapper.children.length; i += 1) {
      if (wrapper.children[i].classList.contains("pplrlabel")) {
        return wrapper.children[i];
      }
    }

    return null;
  }

  function renameLabel(label, text) {
    if (!label || label.getAttribute("data-buntify-renamed") === "1") {
      return;
    }

    var priceSpan = label.querySelector(".pplr_option_price_span");
    label.textContent = text + " ";

    if (priceSpan) {
      label.appendChild(priceSpan);
    }

    label.removeAttribute("onclick");
    label.setAttribute("data-buntify-renamed", "1");
  }

  function makeTrigger(labelText, panelId) {
    var trigger = document.createElement("button");
    var text = document.createElement("span");
    var icon = document.createElement("span");

    trigger.type = "button";
    trigger.className = "pplrlabel buntify-accordion__trigger";
    trigger.setAttribute("aria-expanded", "false");
    trigger.setAttribute("aria-controls", panelId);

    text.className = "buntify-accordion__title";
    text.textContent = labelText;

    icon.className = "buntify-accordion__icon";
    icon.setAttribute("aria-hidden", "true");

    trigger.appendChild(text);
    trigger.appendChild(icon);

    return trigger;
  }

  function getSwatchImageUrl(swatch) {
    var url = swatch.getAttribute("data-image") || swatch.getAttribute("data-psrc");

    if (!url) {
      var source = swatch.querySelector("[data-psrc]");
      if (source) url = source.getAttribute("data-psrc");
    }

    if (!url) {
      var image = swatch.querySelector("img[src]");
      if (image) url = image.getAttribute("src");
    }

    return url || "";
  }

  function cssUrl(url) {
    return 'url("' + String(url).replace(/\\/g, "\\\\").replace(/"/g, '\\"') + '")';
  }

  function restoreSwatchImages(motifWrapper) {
    if (!motifWrapper) return;

    var grids = motifWrapper.querySelectorAll(
      ".pplrgcolor.pplr_thumb_image.pplr-swatch-main"
    );

    Array.prototype.forEach.call(grids, function (grid) {
      grid.style.setProperty("display", "flex", "important");
      grid.style.setProperty("visibility", "visible", "important");
      grid.style.setProperty("opacity", "1", "important");
    });

    var swatches = motifWrapper.querySelectorAll(
      ".pplr-swatch-element.pplrimage"
    );

    Array.prototype.forEach.call(swatches, function (swatch) {
      var imageUrl = getSwatchImageUrl(swatch);

      swatch.style.setProperty("display", "flex", "important");
      swatch.style.setProperty("visibility", "visible", "important");
      swatch.style.setProperty("opacity", "1", "important");
      swatch.style.setProperty("background-position", "center center", "important");
      swatch.style.setProperty("background-size", "contain", "important");
      swatch.style.setProperty("background-repeat", "no-repeat", "important");

      if (imageUrl) {
        swatch.style.setProperty("background-image", cssUrl(imageUrl), "important");
      }
    });

    var lazyImages = motifWrapper.querySelectorAll("img[data-psrc]");
    Array.prototype.forEach.call(lazyImages, function (image) {
      if (!image.getAttribute("src")) {
        image.setAttribute("src", image.getAttribute("data-psrc"));
      }
    });
  }

  function restoreAfterOpen(motifWrapper) {
    restoreSwatchImages(motifWrapper);

    window.requestAnimationFrame(function () {
      restoreSwatchImages(motifWrapper);
    });

    window.setTimeout(function () {
      restoreSwatchImages(motifWrapper);
    }, 80);

    window.setTimeout(function () {
      restoreSwatchImages(motifWrapper);
    }, 300);
  }

  function setOpen(item, open) {
    item.trigger.classList.toggle("is-open", open);
    item.trigger.setAttribute("aria-expanded", open ? "true" : "false");

    item.motifWrapper.classList.toggle("is-collapsed", !open);
    item.motifWrapper.classList.toggle("is-expanded", open);
    item.backgroundWrapper.classList.toggle("is-collapsed", !open);
    item.backgroundWrapper.classList.toggle("is-expanded", open);
    item.nameWrapper.classList.toggle("is-collapsed", !open);
    item.nameWrapper.classList.toggle("is-expanded", open);

    item.motifWrapper.setAttribute("aria-hidden", open ? "false" : "true");
    item.backgroundWrapper.setAttribute("aria-hidden", open ? "false" : "true");
    item.nameWrapper.setAttribute("aria-hidden", open ? "false" : "true");

    if (open) {
      restoreAfterOpen(item.motifWrapper);
    }
  }

  function attachInvalidHandler(item) {
    if (item.nameWrapper.getAttribute("data-buntify-invalid-handler") === "1") {
      return;
    }

    item.nameWrapper.addEventListener(
      "invalid",
      function (event) {
        setOpen(item, true);

        window.requestAnimationFrame(function () {
          if (event.target && typeof event.target.focus === "function") {
            try {
              event.target.focus({ preventScroll: true });
            } catch (error) {
              event.target.focus();
            }
          }
        });
      },
      true
    );

    item.nameWrapper.setAttribute("data-buntify-invalid-handler", "1");
  }

  function initializeSection(root, config, index) {
    var motifWrapper = root.querySelector(config.motifSelector);
    var backgroundWrapper = root.querySelector(config.backgroundSelector);
    var nameWrapper = root.querySelector(config.nameSelector);

    if (!motifWrapper || !backgroundWrapper || !nameWrapper) return false;

    if (motifWrapper.getAttribute("data-buntify-accordion-ready") === "1") {
      return true;
    }

    var motifLabel = findDirectLabel(motifWrapper);
    var nameLabel = findDirectLabel(nameWrapper);

    if (!motifLabel || !nameLabel || !motifWrapper.parentNode) return false;

    var panelId = "buntify-native-panel-" + PRODUCT_ID + "-" + index;
    var trigger = makeTrigger(config.label, panelId);

    trigger.id = "buntify-native-trigger-" + PRODUCT_ID + "-" + index;

    motifWrapper.parentNode.insertBefore(trigger, motifWrapper);

    motifWrapper.id = panelId;
    motifWrapper.setAttribute("role", "region");
    motifWrapper.setAttribute("aria-labelledby", trigger.id);
    motifWrapper.classList.add(
      "buntify-accordion__content",
      "buntify-accordion__motif-wrapper"
    );

    backgroundWrapper.classList.add(
      "buntify-accordion__content",
      "buntify-accordion__background-field"
    );

    nameWrapper.classList.add(
      "buntify-accordion__content",
      "buntify-accordion__name-field"
    );

    motifLabel.classList.add("buntify-accordion__original-label");
    motifLabel.setAttribute("aria-hidden", "true");
    motifLabel.removeAttribute("onclick");

    renameLabel(nameLabel, "Name eingeben");

    var item = {
      trigger: trigger,
      motifWrapper: motifWrapper,
      backgroundWrapper: backgroundWrapper,
      nameWrapper: nameWrapper
    };

    trigger.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();

      setOpen(item, trigger.getAttribute("aria-expanded") !== "true");
    });

    attachInvalidHandler(item);

    motifWrapper.setAttribute("data-buntify-accordion-ready", "1");
    backgroundWrapper.setAttribute("data-buntify-accordion-member", "1");
    nameWrapper.setAttribute("data-buntify-accordion-member", "1");

    setOpen(item, index === 1);
    return true;
  }

  function initializeAll() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return false;

    var allReady = true;

    ACCORDIONS.forEach(function (config, index) {
      if (!initializeSection(root, config, index + 1)) {
        allReady = false;
      }
    });

    if (allReady) {
      root.setAttribute("data-buntify-accordions-ready", "1");
    }

    return allReady;
  }

  function start() {
    if (initializeAll()) return;

    var observer = new MutationObserver(function () {
      if (initializeAll()) {
        observer.disconnect();
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    window.setTimeout(function () {
      observer.disconnect();
      initializeAll();
    }, 5000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();

(function () {
  "use strict";

  function selectDefaultColors(scope) {
    var groups = (scope || document).querySelectorAll(".pplr-color-select");

    Array.prototype.forEach.call(groups, function (group) {
      var alreadySelected = group.querySelector(".pplrColor.selected");
      if (alreadySelected) return;

      var firstSwatch = group.querySelector(".pplr-swatch-element.pplrColor");
      if (firstSwatch) firstSwatch.click();
    });
  }

  function start() {
    selectDefaultColors(document);

    var observer = new MutationObserver(function () {
      selectDefaultColors(document);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    window.setTimeout(function () {
      observer.disconnect();
    }, 5000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();

/* ============================================================
   BUNTIFY – NAMENSAUFKLEBER ACCORDION + AUTO-FARBE + READY-PANEL
   + Neukunden-Angebot in Menge-Step
   Product: 16093135176067
   data-main: 1 Design | 2 Placeholder (hidden) | 3 Hintergrund | 4 Muster
              5 Name | 6 Schriftart | 7 Textfarbe | 11 Anzahl
   ============================================================ */
(function () {
  "use strict";

  var PRODUCT_ID = "16093135176067";
  if (!window.bzOn(PRODUCT_ID)) return;
  var ROOT_SELECTOR = "#pplr-" + PRODUCT_ID;

  var M = { design: "1", placeholder: "2", color: "3", muster: "4",
            name: "5", font: "6", textColor: "7", qty: "11" };

  /* Zepto swaps between two text sets (motif / Kein-Motiv) and removes the unused one.
     Follow whichever text field is currently in the DOM (the one with a textarea). */
  function activeNameMain(root) {
    var ws = root.querySelectorAll("[data-main]");
    for (var i = 0; i < ws.length; i++) {
      if (ws[i].querySelector("textarea.pplr_text")) return ws[i].getAttribute("data-main");
    }
    return null;
  }

  // Hide placeholder upload and Zepto choice labels; field 5 is now the customer name.
  (function injectHideCss() {
    if (document.getElementById("buntify-na-hide-css")) return;
    var R = ROOT_SELECTOR;
    var style = document.createElement("style");
    style.id = "buntify-na-hide-css";
    style.textContent =
      R + ' [data-main="' + M.placeholder + '"]{display:none!important}' +
      R + ' .pplr-choice-label{display:none!important}';
    document.head.appendChild(style);
  })();

  if ("scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual";
  }

  var MOTIF_TO_COLOR = {
    "Schmetterling": "Lila", "schmetterling-02": "Lila",
    "einhörnchen": "Lila",
    "Bellerina": "Lila", "Bellerina-2": "Lila",
    "Blume": "Lila",
    "Meerjungfrau": "Lila",
    "Pferd": "Sandbeige",
    "Katze": "Terrakotta",
    "Erdbeere": "Salbeigrün",
    "Bär": "Sandbeige",
    "Dino": "Salbeigrün", "Dino-02": "Sandbeige",
    "Traktor": "Salbeigrün",
    "Tiger": "Terrakotta", "Tiger-02": "Terrakotta",
    "Löwe-01": "Buttergelb",
    "Fussball": "Taubenblau",
    "Basketball": "Taubenblau",
    "Feuertruck": "Taubenblau",
    "Bagger": "Taubenblau",
    "Rakete": "Taubenblau",
    "Polizeiauto": "Taubenblau",
    "Biene": "Buttergelb", "Biene-02": "Buttergelb",
    "Sonne": "Buttergelb",
    "Giraffe": "Buttergelb",
    "Regenbogen": "Taubenblau",
    "Schildkröte": "Salbeigrün",
    "Fuchs": "Terrakotta", "Fuchs-02": "Terrakotta",
    "Eule-02": "Sandbeige",
    "Igel": "Terrakotta",
    "Koala": "Sandbeige",
    "Panda-01": "Taubenblau",
    "Panda-03": "Sandbeige",
    "Reh": "Sandbeige",
    "Hase-01": "Terrakotta",
    "Astronaut": "Lila",
    "Regenbogen-02": "Lila",
    "Hund": "Sandbeige",
    "Flugzeug": "Terrakotta",
    "Roboter": "Sandbeige",
    "Kuh-03": "Salbeigrün",
    "Delfin-03": "Taubenblau",
    "Elefant-03": "Lila",
    "Pinguin-03": "Taubenblau",
    "Welpe-03": "Sandbeige",
    "Einhorn-03": "Lila",
    "Panda-04": "Sandbeige",
    "Kein-Motiv": "Sandbeige"
  };
  Object.keys(window.BZ_AQ_COLOR || {}).forEach(function (k) { if (!MOTIF_TO_COLOR[k]) MOTIF_TO_COLOR[k] = window.BZ_AQ_COLOR[k]; });
  var FALLBACK_COLOR = "Sandbeige";

  var NAME_DEBOUNCE = 500;

  var COPY = {
    step1: "Selbst gestalten",
    step2Edit: "Hintergrund & Muster",
    step3: "Text: Schrift & Farbe",
    step4: "Menge wählen",
    readyHeadline: function (name) {
      return "Individuell gestaltet für " + (name || "dein Kind") +
        " \u2013 jetzt bestellen und in 2\u20133 Werktagen kostenlos erhalten";
    },
    readySub: "Professionell gedruckt & geschnitten in Stuttgart",
  };


  function findLabel(wrapper) {
    for (var i = 0; i < wrapper.children.length; i++) {
      if (wrapper.children[i].classList.contains("pplrlabel")) return wrapper.children[i];
    }
    return null;
  }

  function hideOriginalLabel(wrapper) {
    var lbl = findLabel(wrapper);
    if (!lbl) return;
    lbl.classList.add("buntify-na-original-label");
    lbl.removeAttribute("onclick");
  }

  function makeTrigger(text, panelId) {
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "buntify-na-trigger";
    btn.setAttribute("aria-expanded", "false");
    btn.setAttribute("aria-controls", panelId);
    var span = document.createElement("span");
    span.className = "buntify-na-trigger__text";
    span.textContent = text;
    var icon = document.createElement("span");
    icon.className = "buntify-na-trigger__icon";
    icon.setAttribute("aria-hidden", "true");
    btn.appendChild(span);
    btn.appendChild(icon);
    return btn;
  }

  function setOpen(step, open) {
    step.trigger.classList.toggle("is-open", open);
    step.trigger.setAttribute("aria-expanded", open ? "true" : "false");
    step.wrapper.classList.toggle("is-collapsed", !open);
    step.wrapper.classList.toggle("is-expanded", open);
  }

  function setDone(step, summary) {
    if (step.subheading) return; // headings inside the "Selbst gestalten" card keep their text
    step.trigger.querySelector(".buntify-na-trigger__text").textContent =
      "\u2713 " + step.baseLabel + (summary ? ": " + summary : "");
    step.trigger.classList.add("is-done");
  }

  function clearDone(step) {
    if (step.subheading) return;
    step.trigger.querySelector(".buntify-na-trigger__text").textContent = step.baseLabel;
    step.trigger.classList.remove("is-done");
  }

  function scrollToStep(step) {
    step.trigger.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function buildStep(root, dataMain, label, index) {
    var wrapper = root.querySelector('[data-main="' + dataMain + '"]');
    if (!wrapper) return null;
    if (wrapper.getAttribute("data-buntify-na-ready") === "1") return null;
    var originalLabel = findLabel(wrapper);
    if (!originalLabel || !wrapper.parentNode) return null;

    var panelId = "buntify-na-panel-" + index;
    var trigger = makeTrigger(label, panelId);
    trigger.id = "buntify-na-trigger-" + index;

    wrapper.parentNode.insertBefore(trigger, wrapper);
    wrapper.id = panelId;
    wrapper.classList.add("buntify-na-content");
    hideOriginalLabel(wrapper);
    wrapper.setAttribute("data-buntify-na-ready", "1");

    return {
      wrapper: wrapper,
      trigger: trigger,
      baseLabel: label,
      dataMain: dataMain
    };
  }

  /* Find each option by its Zepto class, not by position: adding or removing a layer in Zepto
     shifts the data-main numbers (Oct 2026: an extra layer moved Name/Schrift/Textfarbe/Anzahl by one). */
  var mResolved = false;
  function resolveM(root) {
    if (mResolved) return;
    function dm(sel) { var w = root.querySelector(".pplr-wrapper" + sel); return w && w.getAttribute("data-main"); }
    var fw = root.querySelector(".pplr-wrapper.pplr-font-select");
    if (!fw) return; // motif text set not rendered yet
    var v;
    if ((v = dm(".pplr-_design-whlen"))) M.design = v;
    if ((v = dm(".pplr-color-select.pplr-_hintergrund"))) M.color = v;
    if ((v = dm(".pplr-_hintergrund--placeholder"))) M.placeholder = v;
    if ((v = dm(".pplr-muster-whlen"))) M.muster = v;
    if ((v = dm(".pplr-anzahl"))) M.qty = v;
    if ((v = dm(".pplr-textfarbe"))) M.textColor = v;
    M.font = fw.getAttribute("data-main");
    var p = fw.previousElementSibling;
    while (p && !(p.classList.contains("pplr-wrapper") && p.querySelector("textarea.pplr_text"))) p = p.previousElementSibling;
    if (p) M.name = p.getAttribute("data-main");
    mResolved = true;
  }

  function initAccordion() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return false;
    if (root.getAttribute("data-buntify-na-init") === "1") return true;
    resolveM(root);
    if (!mResolved) return false;

    var stepDesign = buildStep(root, M.design, COPY.step1, 1);
    var stepColor  = buildStep(root, M.color,  COPY.step2Edit, 2);
    var name0      = activeNameMain(root);
    var stepName   = name0 && buildStep(root, name0, COPY.step3, 3);
    var stepQty    = buildStep(root, M.qty,    COPY.step4, 4);

    if (!stepDesign || !stepColor || !stepName || !stepQty) return false;

    // Muster wählen -> into Hintergrund panel
    var musterWrapper = root.querySelector('[data-main="' + M.muster + '"]');
    if (musterWrapper) {
      hideOriginalLabel(musterWrapper);
      stepColor.wrapper.appendChild(musterWrapper);
      stepColor.extraContent = [musterWrapper];
    }

    // Schriftart + Textfarbe -> into Name panel
    // only the motif set (field 5) moves font/colour into the box; Kein-Motiv set stays untouched
    stepName.dynamic = true;
    stepName.extraContent = [];
    if (name0 === M.name) {
      var fontSelect  = root.querySelector('[data-main="' + M.font + '"]');
      var colorSelect = root.querySelector('[data-main="' + M.textColor + '"]');
      [fontSelect, colorSelect].forEach(function (el) {
        if (el) stepName.wrapper.appendChild(el);
      });
      stepName.extraContent = [fontSelect, colorSelect].filter(Boolean);
    }

    root.setAttribute("data-buntify-na-init", "1");

    if (!document.getElementById("buntify-na-simple-css")) {
      var simpleCss = document.createElement("style");
      simpleCss.id = "buntify-na-simple-css";
      simpleCss.textContent =
        /* "Selbst gestalten": Design + Hintergrund & Muster + Text in ONE grey card.
           Triggers 2 and 3 become plain headings inside the card, panels join into one box
           (same grey as buntify-apple.css; pplr-wrapper's 22px bottom margin removed inside the card). */
        ROOT_SELECTOR + " #buntify-na-trigger-2," + ROOT_SELECTOR + " #buntify-na-trigger-3{min-height:0!important;margin:-24px 0 0!important;padding:16px 16px 4px!important;background:var(--bz-fill,#F5F5F7)!important;border:0!important;border-radius:0!important;box-shadow:none!important;cursor:default!important;pointer-events:none!important;font-size:15px!important}" +
        ROOT_SELECTOR + " #buntify-na-trigger-2 .buntify-na-trigger__text," + ROOT_SELECTOR + " #buntify-na-trigger-3 .buntify-na-trigger__text{font-size:15px!important}" +
        ROOT_SELECTOR + " #buntify-na-trigger-2 .buntify-na-trigger__icon," + ROOT_SELECTOR + " #buntify-na-trigger-3 .buntify-na-trigger__icon{display:none!important}" +
        ROOT_SELECTOR + " #buntify-na-trigger-2.buntify-na-group-closed," + ROOT_SELECTOR + " #buntify-na-trigger-3.buntify-na-group-closed{display:none!important}" +
        ROOT_SELECTOR + " #buntify-na-panel-1.is-expanded," + ROOT_SELECTOR + " #buntify-na-panel-2.is-expanded{border-radius:0!important;margin-bottom:0!important;padding-bottom:12px!important;border-bottom:1px solid var(--bz-line,#E5E5EA)!important}" +
        ROOT_SELECTOR + " #buntify-na-panel-2.is-expanded," + ROOT_SELECTOR + " #buntify-na-panel-3.is-expanded{border-top:0!important;margin-top:-24px!important;padding-top:8px!important}" +
        ".bf-more-info-btn{display:none!important}" + // "Mehr Informationen" button at the top of the product
        ".buntify-na-ready{display:none!important}" + // "Individuell gestaltet für …" card under Menge wählen
        ROOT_SELECTOR + " .buntify-na-empty-layer{display:none!important}";
      document.head.appendChild(simpleCss);
    }
    // Empty Zepto layers (no swatch, field or text) only add white space between the cards.
    // (Oct 29) Layers that had content once are not re-measured; all reads first, then writes,
    // so one run causes at most one layout instead of one per layer.
    var bzFilledLayers = new WeakSet();
    function hideEmptyLayers() {
      var ws = Array.prototype.slice.call(root.querySelectorAll(":scope > .pplr-wrapper"));
      var res = ws.map(function (w) {
        if (bzFilledLayers.has(w)) return false;
        var empty = !w.querySelector(".pplr-swatch-element, textarea, select, .pplr-drop-item, input:not(.pplr-crop):not([type=hidden])") &&
                    !(w.innerText || "").trim();
        if (!empty) bzFilledLayers.add(w);
        return empty;
      });
      ws.forEach(function (w, i) {
        if (w.classList.contains("buntify-na-empty-layer") !== res[i]) w.classList.toggle("buntify-na-empty-layer", res[i]);
      });
    }
    hideEmptyLayers();

    var allSteps = [stepDesign, stepColor, stepName, stepQty];
    var colorManuallySet = false;
    var selectedMotif = null;
    var nameDebounceTimer = null;
    setTimeout(function () { allSteps.forEach(reacquireStep); }, 0);

    function reacquireStep(step) {
      if (step.dynamic) {
        var nm = activeNameMain(root);
        if (!nm) return;
        step.dataMain = nm;
        var f = nm === M.name ? root.querySelector('[data-main="' + M.font + '"]') : null;
        var c = nm === M.name ? root.querySelector('[data-main="' + M.textColor + '"]') : null;
        step.extraContent = [f, c].filter(Boolean);
      }
      var fresh = root.querySelector('[data-main="' + step.dataMain + '"]');
      if (!fresh) return;
      if (step.dynamic && fresh.previousElementSibling !== step.trigger && fresh.parentNode) {
        fresh.parentNode.insertBefore(step.trigger, fresh);
      }

      if (fresh.id !== step.trigger.getAttribute("aria-controls")) {
        fresh.id = step.trigger.getAttribute("aria-controls");
      }
      step.wrapper = fresh;

      if (!fresh.classList.contains("buntify-na-content")) {
        fresh.classList.add("buntify-na-content");
      }
      hideOriginalLabel(fresh);
      // Kein-Motiv name field: keep Zepto's label visible (it carries the "max. 2 Zeilen à 17 Zeichen" hint)
      if (step.dynamic && step.dataMain !== M.name) {
        var keepLbl = findLabel(fresh);
        if (keepLbl) keepLbl.classList.remove("buntify-na-original-label");
      }

      if (step.extraContent) {
        var extras = Array.isArray(step.extraContent) ? step.extraContent : [step.extraContent];
        extras.forEach(function (el) {
          if (el && !fresh.contains(el)) {
            fresh.appendChild(el);
          }
        });
      }

      var open = step.trigger.getAttribute("aria-expanded") === "true";
      fresh.classList.toggle("is-collapsed", !open);
      fresh.classList.toggle("is-expanded", open);
    }

    var domHealObserver = new MutationObserver(function () {
      if (window.__bzAdding) return; // pause page tweaks while Zepto adds to cart
      allSteps.forEach(reacquireStep);
      hideEmptyLayers();
    });
    domHealObserver.observe(root, { childList: true, subtree: true });

    // Cards that start closed: make sure their pattern/colour images are painted once opened
    function loadPanelImages(panel) {
      window.setTimeout(function () {
        // patterns only: motif swatches keep their own image handling (contain), "cover" would zoom them in
        Array.prototype.forEach.call(panel.querySelectorAll('[data-main="' + M.muster + '"] .pplr-swatch-element.pplrimage'), function (sw) {
          var url = sw.getAttribute("data-thumb") || sw.getAttribute("data-image");
          if (!url || sw.getAttribute("data-buntify-panel-img") === url) return;
          var src = window.bzThumb ? window.bzThumb(url, 160) : url;
          var img = new Image();
          img.onerror = function () { if (src !== url) { src = url; img.src = url; } };
          img.onload = function () {
            sw.style.setProperty("background-image", 'url("' + src.replace(/"/g, '\\"') + '")', "important");
            sw.style.setProperty("background-size", "cover", "important");
            sw.style.setProperty("background-position", "center center", "important");
            sw.setAttribute("data-buntify-panel-img", url);
          };
          img.src = src;
        });
      }, 50);
    }

    function closeAllExcept(keepOpenStep) {
      allSteps.forEach(function (s) {
        reacquireStep(s);
        if (s !== keepOpenStep) setOpen(s, false);
      });
    }

    function goToStep(step) {
      closeAllExcept(step);
      reacquireStep(step);
      setOpen(step, true);
      scrollToStep(step);
    }

    // "Selbst gestalten" = one card: its trigger opens/closes Design, Hintergrund & Muster and Text together.
    // "Menge wählen" stays its own card. Opening one card no longer closes the other.
    var group = [stepDesign, stepColor, stepName];
    stepColor.subheading = true;
    stepName.subheading = true;
    clearDone(stepColor); clearDone(stepName);
    function setGroupOpen(open) {
      group.forEach(function (s) { reacquireStep(s); setOpen(s, open); });
      [stepColor, stepName].forEach(function (s) {
        s.trigger.classList.toggle("buntify-na-group-closed", !open);
        s.trigger.setAttribute("tabindex", "-1");
        s.trigger.setAttribute("aria-hidden", "true");
      });
      if (open) loadPanelImages(stepColor.wrapper);
    }
    stepDesign.trigger.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      var wasOpen = stepDesign.trigger.getAttribute("aria-expanded") === "true";
      setGroupOpen(!wasOpen);
      if (!wasOpen) scrollToStep(stepDesign);
    });
    [stepColor, stepName].forEach(function (s) {
      s.trigger.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); });
    });
    stepQty.trigger.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      reacquireStep(stepQty);
      var wasOpen = stepQty.trigger.getAttribute("aria-expanded") === "true";
      setOpen(stepQty, !wasOpen);
      if (!wasOpen) scrollToStep(stepQty);
    });

    setGroupOpen(false);  // "Selbst gestalten" starts closed ("Fertige Designs" above is the quick way)
        setOpen(stepQty, true);

    // FIX (Oct 2026): "Muster wählen" is required in Zepto but sits in the closed
    // "Selbst gestalten" card. Without a pattern, Zepto silently blocks add-to-cart.
    // -> default to "kein-muster" when nothing is selected.
    function ensureMuster() {
      var w = root.querySelector('[data-main="' + M.muster + '"]');
      var inp = w && w.querySelector('input[name*="Muster"]');
      if (inp && !inp.value) {
        var sw = w.querySelector('.pplr-swatch-element[data-val="kein-muster"]');
        if (sw) sw.click();
      }
    }
    ensureMuster();
    window.setTimeout(ensureMuster, 1500);
    window.setTimeout(ensureMuster, 4000);

    // Safety net: if a required field is still empty and hidden on add-to-cart,
    // fill the pattern and open the card so Zepto's red hint is visible.
    document.addEventListener("click", function (e) {
      if (!e.target.closest || !e.target.closest('[id*="ProductSubmitButton"], .add-to-cart-button')) return;
      ensureMuster();
      var missing = Array.prototype.some.call(
        root.querySelectorAll('input[required]:not([disabled]), textarea[required]'),
        function (i) { return !String(i.value).trim() && !i.offsetParent; }
      );
      if (missing && stepDesign.trigger.getAttribute("aria-expanded") !== "true") setGroupOpen(true);
    }, true);

    var form = root.closest("form");
    var buyButtons = form && form.querySelector(".product-form-buttons");
    var readyPanel = document.createElement("div");
    readyPanel.className = "buntify-na-ready is-hidden";
    readyPanel.innerHTML =
      '<p class="buntify-na-ready__headline"></p>' +
      '<p class="buntify-na-ready__sub">' + COPY.readySub + "</p>";
    if (buyButtons && buyButtons.parentNode) {
      buyButtons.parentNode.insertBefore(readyPanel, buyButtons);
    }

    function currentNameInput() {
      var nm = activeNameMain(root);
      return nm ? root.querySelector('[data-main="' + nm + '"] textarea.pplr_text') : null;
    }
    function currentName() {
      var ta = currentNameInput();
      return ta ? ta.value.trim().split("\n")[0] : "";
    }
    function refreshReadyPanel() {
      var name = currentName();
      if (!name) {
        readyPanel.classList.add("is-hidden");
        return;
      }
      readyPanel.classList.remove("is-hidden");
      readyPanel.querySelector(".buntify-na-ready__headline").textContent =
        COPY.readyHeadline(name);
    }

    // Design click -> auto background colour
    // (Oct 29) Runs after the design tap has painted, so Zepto's second canvas redraw
    // (for the colour) is no longer part of the tap's response time (INP).
    root.addEventListener("click", function (e) {
      var swatch = e.target.closest(".pplr-swatch-element.pplrimage");
      if (!swatch || !swatch.closest('[data-main="' + M.design + '"]')) return;
      selectedMotif = swatch.getAttribute("data-val");

      window.requestAnimationFrame(function () { window.setTimeout(function () { // after the design has painted
        // (Oct 29) A "Fertige Designs" card sets its own background: do not fight it with the motif default
        // (that cost extra Zepto redraws and could leave the wrong background/text colour).
        if (!colorManuallySet && !window.__bzPresetApplying) {
          var colorName = MOTIF_TO_COLOR[selectedMotif] || FALLBACK_COLOR;
          var colorSwatch = root.querySelector(
            '[data-main="' + M.color + '"] .pplr-swatch-element.pplrColor[data-name="' + colorName + '"]'
          );
          if (colorSwatch) colorSwatch.click();
          setDone(stepColor, colorName);
        }
        setDone(stepDesign, selectedMotif);
      }, 0); });
    });

    // Manual background colour
    root.addEventListener("click", function (e) {
      var swatch = e.target.closest(".pplr-swatch-element.pplrColor");
      if (!swatch || !swatch.closest('[data-main="' + M.color + '"]')) return;
      if (e.isTrusted) {
        colorManuallySet = true;
      }
      setDone(stepColor, swatch.getAttribute("data-name") || "");
    });

    // Name input
    root.addEventListener("input", function (e) {
      if (!e.target.matches("textarea.pplr_text") || !e.target.closest('[data-main="' + activeNameMain(root) + '"]')) return;
      refreshReadyPanel();

      var value = e.target.value.trim();
      if (nameDebounceTimer) window.clearTimeout(nameDebounceTimer);
      if (!value) {
        clearDone(stepName);
        return;
      }

      nameDebounceTimer = window.setTimeout(function () {
        setDone(stepName, value);
      }, NAME_DEBOUNCE);
    });

    // Quantity
    (function markInitialQtySelection() {
      var active = root.querySelector('[data-main="' + M.qty + '"] .pplr-drop-item.active');
      if (active) {
        setDone(stepQty, (active.getAttribute("data-value") || "").trim());
      }
    })();

    root.addEventListener("click", function (e) {
      var item = e.target.closest(".pplr-drop-item");
      if (!item || !item.closest('[data-main="' + M.qty + '"]')) return;
      window.setTimeout(function () {
        var active = root.querySelector('[data-main="' + M.qty + '"] .pplr-drop-item.active');
        setDone(stepQty, active ? (active.getAttribute("data-value") || "").trim() : "");
        refreshReadyPanel();
      }, 0);
    });


    // Move "Neukunden Angebot" into the Menge step
    function moveOffer() {
      var offer = document.getElementById("nka-modern");
      if (!offer) return false;
      if (offer.getAttribute("data-buntify-moved") === "1") return true;
      stepQty.wrapper.appendChild(offer);
      offer.setAttribute("data-buntify-moved", "1");
      return true;
    }
    if (!moveOffer()) {
      var offerObs = new MutationObserver(function () {
        if (moveOffer()) offerObs.disconnect();
      });
      offerObs.observe(document.documentElement, { childList: true, subtree: true });
      window.setTimeout(function () { offerObs.disconnect(); }, 8000);
    }

    return true;
  }

  function start() {
    if (initAccordion()) return;
    var observer = new MutationObserver(function () {
      if (initAccordion()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 8000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();

/* ============================================================
   BUNTIFY – ALTENHEIM / PFLEGEHEIM NAMENSETIKETTEN
   Product: 16379882635651  (same design as Namensaufkleber)
   ============================================================ */
(function () {
  "use strict";

  var PRODUCT_ID = "16379882635651";
  if (!window.bzOn(PRODUCT_ID)) return;
  var ROOT_SELECTOR = "#pplr-" + PRODUCT_ID;

  /* ---------- Zepto fields of this product ----------
     Found by their option name, not by number: adding or deleting a field in Zepto
     shifts the numbers, which used to break this layout. */
  var M = { design: "-", placeholder: "-", color: "-", muster: "-",
            name: "-", font: "-", textColor: "-", qty: "-" };
  function dmOf(root, sel) {
    var w = root.querySelector(".pplr-wrapper" + sel);
    return (w && w.getAttribute("data-main")) || "-";
  }
  function resolveFields(root) {
    M.design = dmOf(root, ".pplr-_motiv-hinzufgen");
    if (M.design === "-") M.design = dmOf(root, ".pplr-_design-whlen");
    M.placeholder = dmOf(root, ".pplr-_hintergrund--placeholder");
    M.color = dmOf(root, ".pplr-color-select.pplr-_hintergrund");
    M.muster = dmOf(root, ".pplr-muster-whlen");
    M.qty = dmOf(root, ".pplr-anzahl");
    var t = root.querySelector(".pplr-wrapper textarea.pplr_text");
    M.name = t ? t.closest(".pplr-wrapper").getAttribute("data-main") : "-";
    NAME_SETS[0].name = M.name;
  }

  /* Two text sets: A (6/7/8) = with motif, B (9/10/11) = Kein-Motiv.
     Zepto removes the inactive set from the DOM, so we follow whichever is present. */
  var NAME_SETS = [
    { name: "-", font: "-", color: "-" }
  ];
  /* Zepto swaps the name field (with motif: 15 characters, "Kein-Motiv": 13 characters).
     Always follow the name field that is currently there. */
  function activeSet(root) {
    var t = root.querySelector(".pplr-wrapper textarea.pplr_text, .pplr-wrapper input.pplr_text");
    if (!t) return null;
    NAME_SETS[0].name = M.name = t.closest(".pplr-wrapper").getAttribute("data-main");
    return NAME_SETS[0];
  }

  /* ---------- quantity cards (adjust prices here) ---------- */
  var CARDS = {
    "40":  { title: "40 Aufkleber",  price: "9,99 €",  oldPrice: "", perPiece: "0,25 €/Stk.", badge: null },
    "80":  { title: "80 Aufkleber",  price: "14,99 €", oldPrice: "", perPiece: "0,19 €/Stk.", badge: null },
    "120": { title: "120 Aufkleber", price: "16,99 €", oldPrice: "", perPiece: "0,14 €/Stk.", badge: "Beste Wahl" }
  };
  var DEFAULT_QTY = "120";

  /* ---------- design -> background colour ---------- */
  var MOTIF_TO_COLOR = {
    "Kein-Motiv": "Sandbeige",
    "Volgel-01": "Taubenblau", "Vogel-01": "Taubenblau", "Vogel-02": "Taubenblau",
    "Baum-01": "Salbeigrün", "Baum-02": "Salbeigrün",
    "Herzblume": "Terrakotta",
    "Frangipani": "Buttergelb",
    "Dahlie": "Lila",
    "Blatt": "Salbeigrün",
    "Ahornblatt": "Terrakotta"
  };
  Object.keys(window.BZ_AQ_COLOR || {}).forEach(function (k) { if (!MOTIF_TO_COLOR[k]) MOTIF_TO_COLOR[k] = window.BZ_AQ_COLOR[k]; });
  var FALLBACK_COLOR = "Sandbeige";
  var NAME_DEBOUNCE = 500;

  var COPY = {
    step1: "2. Motiv hinzufügen",
    step2: "Hintergrundfarbe anpassen",
    step3: "3. Name eingeben",
    step4: "1. Menge wählen",
    readyHeadline: function (name) {
      return "Individuell gestaltet für " + (name || "Sie") +
        " \u2013 jetzt bestellen und in 2\u20133 Werktagen kostenlos erhalten";
    },
    readySub: "Professionell gedruckt & geschnitten in Stuttgart",
  };

  /* ============================================================
     CSS (scoped to this product)
     ============================================================ */
  (function injectCss() {
    if (document.getElementById("buntify-ah-css")) return;
    var R = "#pplr-" + PRODUCT_ID;
    var css = [
      R + ' .pplr-_hintergrund--placeholder{display:none!important}',
      // empty image layers from Zepto (no options) -> hide, they showed up as an empty grey box
      R + ' > .pplr-wrapper.pplr-color-select:not(.pplr-_hintergrund):not(:has(.pplr-swatch-element)){display:none!important}',
      // keep the rounded bottom of every open card (also the "Kein-Motiv" name field)
      'html[data-bz-apple] #MainContent ' + R + ' .buntify-na-content.is-expanded{border-radius:0 0 18px 18px!important}',
      R + ' .pplr-choice-label{display:none!important}',
      R + ' .buntify-na-original-label{display:none!important}',
      R + ' .buntify-na-content.is-collapsed{display:none!important}',
      R + ' .buntify-na-content.is-expanded{display:flex!important;flex-direction:column!important;gap:24px!important;padding:14px 14px 16px!important;margin-top:-24px!important;background:#fff!important;border:1.5px solid #9fc4e7!important;border-top:none!important;border-radius:0 0 14px 14px!important;box-sizing:border-box!important}',
      R + ' .buntify-na-trigger{display:flex!important;align-items:center!important;justify-content:space-between!important;gap:14px!important;width:100%!important;min-height:56px!important;box-sizing:border-box!important;margin:0!important;padding:13px 15px!important;appearance:none!important;-webkit-appearance:none!important;background:#f8fbfe!important;border:1.5px solid #dfe8f2!important;border-radius:14px!important;color:#1a1a1a!important;font:inherit!important;font-size:15px!important;font-weight:700!important;text-align:left!important;cursor:pointer!important;outline:none!important;box-shadow:0 2px 10px rgba(27,67,103,.05)!important;-webkit-tap-highlight-color:transparent!important;transition:border-color .18s ease,box-shadow .18s ease,background-color .18s ease!important;pointer-events:auto!important;scroll-margin-top:24px}',
      R + ' .buntify-na-trigger *{pointer-events:none!important}',
      R + ' .buntify-na-trigger:hover,' + R + ' .buntify-na-trigger.is-open{border-color:#9fc4e7!important;background:#f1f7fc!important;box-shadow:0 5px 18px rgba(91,155,213,.13)!important}',
      R + ' .buntify-na-trigger.is-open{border-radius:14px 14px 0 0!important;border-bottom-color:#9fc4e7!important}',
      R + ' .buntify-na-trigger:focus-visible{box-shadow:0 0 0 3px rgba(91,155,213,.22)!important}',
      R + ' .buntify-na-trigger.is-done .buntify-na-trigger__text{color:#2e7d32!important}',
      R + ' .buntify-na-trigger__text{min-width:0!important;line-height:1.35!important;white-space:normal!important}',
      R + ' .buntify-na-trigger__icon{position:relative!important;flex:0 0 28px!important;width:28px!important;height:28px!important;border-radius:50%!important;background:#eaf3fb!important}',
      R + ' .buntify-na-trigger__icon::before,' + R + ' .buntify-na-trigger__icon::after{content:""!important;position:absolute!important;top:50%!important;left:50%!important;width:12px!important;height:2px!important;background:#4f82b2!important;border-radius:999px!important;transform:translate(-50%,-50%)!important;transition:opacity .18s ease!important}',
      R + ' .buntify-na-trigger__icon::after{transform:translate(-50%,-50%) rotate(90deg)!important}',
      R + ' .buntify-na-trigger.is-open .buntify-na-trigger__icon{background:#dcecf9!important}',
      R + ' .buntify-na-trigger.is-open .buntify-na-trigger__icon::after{opacity:0!important}',
    R + ' .pplr-field-box{display:flex!important;flex-direction:column!important;align-items:stretch!important;width:100%!important;position:relative!important;margin:0!important;padding:0!important}',
R + ' .pplr-field-box .pplr-character-count{position:static!important;display:block!important;order:-1!important;align-self:flex-end!important;float:none!important;margin:0 0 6px!important;padding:0!important;font-size:12px!important;line-height:1.2!important;color:#8a94a3!important;background:transparent!important;text-align:right!important}',
R + ' .pplr-field-box textarea.pplr_text{display:block!important;width:100%!important;box-sizing:border-box!important;margin:0!important}',
R + ' .buntify-na-content .pplr-character-count{position:static!important;float:none!important}',
      R + ' #nka-modern{margin:4px 0 14px!important}',
      R + ' .buntify-na-content .pplr_option_price_span:empty{display:none!important}',
      R + ' .pplr-font-select>.pplrlabel,' + R + ' .pplr-color-select>.pplrlabel{display:block!important;margin:0 0 2px!important;color:#1a1a1a!important;font-size:14px!important;font-weight:700!important;line-height:1.35!important}',
      R + ' .pplr-color-select .pplr-swatch-element.pplrColor{width:54px!important;height:54px!important}',
      '.buntify-na-ready{margin:4px 0 14px!important;padding:14px 16px!important;background:#f4f9f4!important;border:1.5px solid #cfe6cf!important;border-radius:14px!important;text-align:left!important}',
      '.buntify-na-ready.is-hidden{display:none!important}',
      '.buntify-na-ready__headline{margin:0 0 4px!important;font-size:15px!important;font-weight:700!important;color:#1a1a1a!important}',
      '.buntify-na-ready__sub{margin:0!important;font-size:13px!important;color:#4b4b4b!important}',
      '@media screen and (max-width:749px){' + R + ' .buntify-na-trigger{scroll-margin-top:220px}}',
      '@media (max-width:768px){' +
        R + ' .buntify-na-trigger{min-height:52px!important;padding:12px 13px!important;font-size:14px!important}' +
        R + ' .buntify-na-content.is-expanded{padding:12px 10px 14px!important}' +
        R + ' .pplr-color-select .pplr-swatch-element.pplrColor{width:50px!important;height:50px!important}' +
        '.buntify-na-ready{padding:12px 14px!important}}'
    ].join("\n");
    var style = document.createElement("style");
    style.id = "buntify-ah-css";
    style.textContent = css;
    document.head.appendChild(style);
  })();

  /* ============================================================
     Helpers
     ============================================================ */
  if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";


  function findLabel(wrapper) {
    for (var i = 0; i < wrapper.children.length; i++) {
      if (wrapper.children[i].classList.contains("pplrlabel")) return wrapper.children[i];
    }
    return null;
  }

  function hideOriginalLabel(wrapper) {
    var lbl = findLabel(wrapper);
    if (!lbl) return;
    lbl.classList.add("buntify-na-original-label");
    lbl.removeAttribute("onclick");
  }

  function makeTrigger(text, panelId) {
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "buntify-na-trigger";
    btn.setAttribute("aria-expanded", "false");
    btn.setAttribute("aria-controls", panelId);
    var span = document.createElement("span");
    span.className = "buntify-na-trigger__text";
    span.textContent = text;
    var icon = document.createElement("span");
    icon.className = "buntify-na-trigger__icon";
    icon.setAttribute("aria-hidden", "true");
    btn.appendChild(span);
    btn.appendChild(icon);
    return btn;
  }

  function setOpen(step, open) {
    step.trigger.classList.toggle("is-open", open);
    step.trigger.setAttribute("aria-expanded", open ? "true" : "false");
    step.wrapper.classList.toggle("is-collapsed", !open);
    step.wrapper.classList.toggle("is-expanded", open);
  }

  function setDone(step, summary) {
    step.trigger.querySelector(".buntify-na-trigger__text").textContent =
      "\u2713 " + step.baseLabel + (summary ? ": " + summary : "");
    step.trigger.classList.add("is-done");
  }

  function clearDone(step) {
    step.trigger.querySelector(".buntify-na-trigger__text").textContent = step.baseLabel;
    step.trigger.classList.remove("is-done");
  }

  function scrollToStep(step) {
    step.trigger.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function buildStep(root, dataMain, label, index) {
    var wrapper = root.querySelector('[data-main="' + dataMain + '"]');
    if (!wrapper) return null;
    if (wrapper.getAttribute("data-buntify-na-ready") === "1") return null;
    var originalLabel = findLabel(wrapper);
    if (!originalLabel || !wrapper.parentNode) return null;

    var panelId = "buntify-ah-panel-" + index;
    var trigger = makeTrigger(label, panelId);
    trigger.id = "buntify-ah-trigger-" + index;

    wrapper.parentNode.insertBefore(trigger, wrapper);
    wrapper.id = panelId;
    wrapper.classList.add("buntify-na-content");
    hideOriginalLabel(wrapper);
    wrapper.setAttribute("data-buntify-na-ready", "1");

    return { wrapper: wrapper, trigger: trigger, baseLabel: label, dataMain: dataMain };
  }

  /* ============================================================
     Quantity cards
     ============================================================ */
  function renderCards(root) {
    var items = root.querySelectorAll('[data-main="' + M.qty + '"] .pplr-drop-item');
    Array.prototype.forEach.call(items, function (item) {
      if (item.querySelector(".pplr-drop-price")) return; // already rendered
      var raw = (item.getAttribute("data-value") || "").trim();
      var d = CARDS[raw];
      if (!d) return;

      var preserved = Array.prototype.filter.call(item.children, function (n) {
        return !n.classList.contains("pplr-drop-title");
      });

      item.innerHTML =
        (d.badge ? '<div class="pplr-drop-ribbon">' + d.badge + "</div>" : "") +
        '<span class="pplr-drop-title">' + d.title + "</span>" +
        '<span class="pplr-drop-price-wrap">' +
          (d.oldPrice ? '<span class="pplr-drop-price-old" style="text-decoration:line-through;color:#999;font-size:1.1em;margin-right:6px;">' + d.oldPrice + "</span>" : "") +
          '<span class="pplr-drop-price" style="font-size:1.3em;font-weight:bold;">' + d.price + "</span>" +
          (d.perPiece ? '<span class="pplr-unit-price">' + d.perPiece + "</span>" : "") +
        "</span>";

      preserved.forEach(function (n) { item.appendChild(n); });
      item.setAttribute("data-enhanced", "1");
      if (d.badge) item.classList.add("pplr-drop-item--bestseller");
    });
  }

  /* ============================================================
     Main init
     ============================================================ */
  function initAccordion() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return false;
    if (root.getAttribute("data-buntify-ah-init") === "1") return true;

    resolveFields(root);
    var stepDesign = buildStep(root, M.design, COPY.step1, 1);
    var stepColor  = buildStep(root, M.color,  COPY.step2, 2);
    var set0       = activeSet(root);
    var stepName   = set0 && buildStep(root, set0.name, COPY.step3, 3);
    var stepQty    = buildStep(root, M.qty,    COPY.step4, 4);
    if (!stepDesign || !stepColor || !stepName || !stepQty) return false;

    // Fixed order on the page, whatever order the fields have in Zepto:
    // 1. Menge -> 2. Motiv -> 3. Name -> Hintergrund (+ Muster)
    [stepColor, stepName, stepDesign, stepQty].forEach(function (st) {
      root.insertBefore(st.wrapper, root.firstChild);
      root.insertBefore(st.trigger, st.wrapper);
    });

    // Muster -> into Hintergrund panel
    var musterWrapper = root.querySelector('[data-main="' + M.muster + '"]');
    if (musterWrapper) {
      hideOriginalLabel(musterWrapper);
      stepColor.wrapper.appendChild(musterWrapper);
      stepColor.extraContent = [musterWrapper];
    }

    // Schriftart + Textfarbe -> into Name panel
    stepName.dynamic = true;
    stepName.extraContent = [];
    (function () {
      var fontSelect  = root.querySelector('[data-main="' + set0.font + '"]');
      var colorSelect = root.querySelector('[data-main="' + set0.color + '"]');
      [fontSelect, colorSelect].forEach(function (el) {
        if (el) stepName.wrapper.appendChild(el);
      });
      stepName.extraContent = [fontSelect, colorSelect].filter(Boolean);
    })();

    root.setAttribute("data-buntify-ah-init", "1");

    var allSteps = [stepDesign, stepColor, stepName, stepQty];
    var colorManuallySet = false;
    var selectedMotif = null;
    var nameDebounceTimer = null;
    setTimeout(function () { allSteps.forEach(reacquireStep); }, 0);

    function reacquireStep(step) {
      if (step.dynamic) {
        var set = activeSet(root);
        if (!set) return;
        step.dataMain = set.name;
        // only set A (6) moves its font/colour into the box; set B stays untouched
        var f = set.name === M.name ? root.querySelector('[data-main="' + set.font + '"]') : null;
        var c = set.name === M.name ? root.querySelector('[data-main="' + set.color + '"]') : null;
        step.extraContent = [f, c].filter(Boolean);
      }
      var fresh = root.querySelector('[data-main="' + step.dataMain + '"]');
      if (!fresh) return;
      // keep the (new) name field right under its "Name eingeben" heading
      if (step.dynamic && fresh.previousElementSibling !== step.trigger && step.trigger.parentNode) {
        step.trigger.parentNode.insertBefore(fresh, step.trigger.nextSibling);
      }
      if (fresh.id !== step.trigger.getAttribute("aria-controls")) {
        fresh.id = step.trigger.getAttribute("aria-controls");
      }
      step.wrapper = fresh;
      if (!fresh.classList.contains("buntify-na-content")) fresh.classList.add("buntify-na-content");
      hideOriginalLabel(fresh);
      // Kein-Motiv name field: keep Zepto's label visible (it carries the "max. 2 Zeilen à 17 Zeichen" hint)
      if (step.dynamic && step.dataMain !== M.name) {
        var keepLbl = findLabel(fresh);
        if (keepLbl) keepLbl.classList.remove("buntify-na-original-label");
      }

      if (step.extraContent) {
        step.extraContent.forEach(function (el) {
          if (el && !fresh.contains(el)) fresh.appendChild(el);
        });
      }
      var open = step.trigger.getAttribute("aria-expanded") === "true";
      fresh.classList.toggle("is-collapsed", !open);
      fresh.classList.toggle("is-expanded", open);
    }

    new MutationObserver(function () {
      if (window.__bzAdding) return; // pause page tweaks while Zepto adds to cart
      allSteps.forEach(reacquireStep);
      renderCards(root);
    }).observe(root, { childList: true, subtree: true });

    function closeAllExcept(keep) {
      allSteps.forEach(function (s) {
        reacquireStep(s);
        if (s !== keep) setOpen(s, false);
      });
    }

    function goToStep(step) {
      closeAllExcept(step);
      reacquireStep(step);
      setOpen(step, true);
      scrollToStep(step);
    }

    allSteps.forEach(function (step) {
      step.trigger.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        reacquireStep(step);
        var wasOpen = step.trigger.getAttribute("aria-expanded") === "true";
        closeAllExcept(step);
        setOpen(step, !wasOpen);
        if (!wasOpen) scrollToStep(step);
      });
    });

    allSteps.forEach(function (s) { setOpen(s, true); });

    /* ---- ready panel ("Individuell gestaltet für …") removed for this product ---- */

    function currentNameInput() {
      return root.querySelector('[data-main="' + M.name + '"] textarea.pplr_text');
    }
    function currentName() {
      var ta = currentNameInput();
      return ta ? ta.value.trim().split("\n")[0] : "";
    }
    function refreshReadyPanel() {}

    /* ---- design click -> auto colour ---- */
    root.addEventListener("click", function (e) {
      var swatch = e.target.closest(".pplr-swatch-element.pplrimage");
      if (!swatch || !swatch.closest('[data-main="' + M.design + '"]')) return;
      selectedMotif = swatch.getAttribute("data-val");

      window.setTimeout(function () {
        if (!colorManuallySet) {
          var colorName = MOTIF_TO_COLOR[selectedMotif] || FALLBACK_COLOR;
          var colorSwatch = root.querySelector(
            '[data-main="' + M.color + '"] .pplr-swatch-element.pplrColor[data-name="' + colorName + '"]'
          );
          if (colorSwatch) colorSwatch.click();
          setDone(stepColor, colorName);
        }
        setDone(stepDesign, selectedMotif);
      }, 0);
    });

    /* ---- manual background colour ---- */
    root.addEventListener("click", function (e) {
      var swatch = e.target.closest(".pplr-swatch-element.pplrColor");
      if (!swatch || !swatch.closest('[data-main="' + M.color + '"]')) return;
      if (e.isTrusted) colorManuallySet = true;
      setDone(stepColor, swatch.getAttribute("data-name") || "");
    });

    /* ---- name input ---- */
    root.addEventListener("input", function (e) {
      if (!e.target.matches("textarea.pplr_text") || !e.target.closest('[data-main="' + M.name + '"]')) return;
      refreshReadyPanel();
      var value = e.target.value.trim();
      if (nameDebounceTimer) window.clearTimeout(nameDebounceTimer);
      if (!value) { clearDone(stepName); return; }
      nameDebounceTimer = window.setTimeout(function () { setDone(stepName, value); }, NAME_DEBOUNCE);
    });

    /* ---- quantity ---- */
    function qtyLabel(active) {
      if (!active) return "";
      var v = (active.getAttribute("data-value") || "").trim();
      return /^\d+$/.test(v) ? v + " Stk." : v;
    }
    function markQty() {
      var active = root.querySelector('[data-main="' + M.qty + '"] .pplr-drop-item.active');
      if (active) setDone(stepQty, qtyLabel(active)); else clearDone(stepQty);
      refreshReadyPanel();
    }

    renderCards(root);

    // default selection
    var defItem = root.querySelector('[data-main="' + M.qty + '"] .pplr-drop-item[data-value="' + DEFAULT_QTY + '"]');
    if (defItem && !defItem.classList.contains("active")) defItem.click();
    markQty();

    root.addEventListener("click", function (e) {
      var item = e.target.closest(".pplr-drop-item");
      if (!item || !item.closest('[data-main="' + M.qty + '"]')) return;
      window.setTimeout(markQty, 0);
    });


    /* ---- move "Neukunden Angebot" into Menge step (if present) ---- */
    function moveOffer() {
      var offer = document.getElementById("nka-modern");
      if (!offer) return false;
      if (offer.getAttribute("data-buntify-moved") === "1") return true;
      stepQty.wrapper.appendChild(offer);
      offer.setAttribute("data-buntify-moved", "1");
      return true;
    }
    if (!moveOffer()) {
      var offerObs = new MutationObserver(function () { if (moveOffer()) offerObs.disconnect(); });
      offerObs.observe(document.documentElement, { childList: true, subtree: true });
      window.setTimeout(function () { offerObs.disconnect(); }, 8000);
    }

    return true;
  }

  function start() {
    if (initAccordion()) return;
    var observer = new MutationObserver(function () {
      if (initAccordion()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 8000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();







/* Buntify Etsy-only preview v17: load after existing Zepto scripts. */
(function () {
  'use strict';
  const ID = '16382167712131';
  const rootSelector = '#pplr-' + ID;
  const etsyUrl = new URLSearchParams(location.search).get('etsy_return');
  // Configure an exact Etsy listing URL here; never redirect to arbitrary query URLs.
  const ETSY_LISTING_URL = 'https://www.etsy.com/listing/4543606857/personalized-name-stickers-for-children';
  const allowedReturn = etsyUrl && /^https:\/\/(www\.)?etsy\.com\//i.test(etsyUrl) ? etsyUrl : ETSY_LISTING_URL;
  const active = () => !!document.querySelector(rootSelector) ||
    String(window.ShopifyAnalytics?.meta?.product?.id || window.meta?.product?.id || '') === ID;
  if (!active()) return;
  document.documentElement.classList.add('buntify-etsy-mode');
  const style = document.createElement('style');
  style.textContent = `
    .buntify-etsy-mode header, .buntify-etsy-mode footer,
    .buntify-etsy-mode .shopify-section-group-header-group,
    .buntify-etsy-mode .shopify-section-group-footer-group,
    .buntify-etsy-mode .product-recommendations,
    .buntify-etsy-mode related-products,
    .buntify-etsy-mode .product-form-buttons,
    .buntify-etsy-mode .shopify-payment-button,
    .buntify-etsy-mode .price,
    .buntify-etsy-mode .product__price,
    .buntify-etsy-mode .cart-drawer,
    .buntify-etsy-mode .predictive-search,
    .buntify-etsy-mode .breadcrumb,
    .buntify-etsy-mode .breadcrumbs,
    .buntify-etsy-mode .sticky-add-to-cart__bar,
    .buntify-etsy-mode sticky-add-to-cart,
    .buntify-etsy-mode .sticky-add-to-cart,
    .buntify-etsy-mode .jdgm-review-widget,
    .buntify-etsy-mode .jdgm-widget,
    .buntify-etsy-mode .jdgm-carousel-wrapper,
    .buntify-etsy-mode .liefer-status,
    .buntify-etsy-mode .pplr-wrapper.pplr-anzahl,
    .buntify-etsy-mode a[href="#bf-spec-details"],
    .buntify-etsy-mode a[href$="#bf-spec-details"],
    .buntify-etsy-mode img[src*="mig2.png"] { display:none !important; }
    /* Fix theme flex wrapping and spacing around the Zepto configurator. */
    .buntify-etsy-mode .layout-panel-flex:has(#pplr-16382167712131) {
      --flex-wrap-mobile: nowrap !important;
      --gap: 0px !important;
      row-gap: 0 !important;
      min-height: 0 !important;
    }
    .buntify-etsy-mode #buntify-etsy-summary {max-width:650px;margin:0 auto;padding:20px;border:1px solid #dce6ef;border-radius:16px;background:#fff;color:#1a1a1a}

    /* Etsy options: consistent card/box styling, scoped to this product. */
    .buntify-etsy-mode #pplr-16382167712131 > .pplr-wrapper,
    .buntify-etsy-mode #pplr-16382167712131 .product-personalizer > .pplr-wrapper {
      box-sizing:border-box!important;width:100%!important;padding:14px 16px!important;
      border:1.5px solid #dfe8f2!important;border-radius:14px!important;
      background:#f8fbfe!important;box-shadow:0 2px 10px rgba(27,67,103,.05)!important;
      margin:0 0 12px!important;
    }
    .buntify-etsy-mode #pplr-16382167712131 .buntify-motif-tabs {display:flex!important;gap:8px!important;flex-wrap:wrap!important;margin:0 0 12px!important}
    .buntify-etsy-mode #pplr-16382167712131 .buntify-motif-tab {padding:9px 16px!important;border-radius:999px!important;border:1.5px solid #e0e0e0!important;background:#fff!important;color:#555!important;font-size:13px!important;font-weight:700!important;cursor:pointer!important;white-space:nowrap!important}
    .buntify-etsy-mode #pplr-16382167712131 .buntify-motif-tab:hover {border-color:#5B9BD5!important;color:#5B9BD5!important}
    .buntify-etsy-mode #pplr-16382167712131 .buntify-motif-tab.is-active {background:#5B9BD5!important;border-color:#5B9BD5!important;color:#fff!important}
    .buntify-etsy-mode #pplr-16382167712131 .buntify-motif-tab--bestseller.is-active {background:#e53935!important;border-color:#e53935!important}
    @media(max-width:480px){.buntify-etsy-mode #pplr-16382167712131 .buntify-motif-tab{padding:8px 13px!important;font-size:12px!important}}
    #buntify-etsy-summary h2 {font-size:20px;margin:0 0 8px}
    #buntify-etsy-summary p {font-size:14px;margin:0 0 12px}
    #buntify-etsy-summary .selection-row {display:flex;gap:8px;align-items:center}
    #buntify-etsy-summary input[data-etsy-selection] {user-select:text;display:block;flex:1;min-width:0;height:48px;padding:12px;border:1px solid #bbb;border-radius:10px;box-sizing:border-box;font:14px/1.5 system-ui;}
    #buntify-etsy-summary button[data-copy] {width:48px;min-width:48px;height:48px;margin:0;padding:0;display:flex;align-items:center;justify-content:center}
    #buntify-etsy-summary button[data-copy] svg {width:20px;height:20px}
    #buntify-etsy-summary button {display:block;width:100%;padding:14px;margin-top:10px;border:0;border-radius:10px;background:#28699c;color:white;font-weight:700;cursor:pointer}
    #buntify-etsy-summary button.secondary {background:white;color:#28699c;border:1px solid #28699c}
    #buntify-etsy-summary .status {min-height:20px;margin-top:8px}
  `;
  document.head.appendChild(style);
  // Prevent accidental purchase from this page, even if a theme button reappears.
  document.addEventListener('submit', e => {
    if (e.target.matches('form[action*="/cart/add"]') || e.target.querySelector('[name="id"]')) {
      e.preventDefault(); e.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('click', e => {
    const link = e.target.closest('a[href]');
    if (!link || link.closest('#buntify-etsy-summary') || link.hasAttribute('download') || /^(blob|data):/i.test(link.getAttribute('href') || '')) return;
    const url = new URL(link.href, location.href);
    if (url.origin === location.origin && !url.hash) e.preventDefault();
  }, true);
  function getSelection(wrapper) {
    const textInput = wrapper.querySelector('textarea.pplr_text, input.pplr_text, input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"])');
    if (textInput && textInput.value.trim()) return textInput.value.trim();
    const selected = wrapper.querySelector('.pplr-drop-item.active, .pplr-swatch-element.selected, .pplr-swatch-element[aria-selected="true"], .pplr-selecter-item.selected-font, .pplr-selecter-item.selected, .pplrColor.selected, select');
    if (selected) {
      if (selected.tagName === 'SELECT') return selected.selectedOptions[0]?.textContent?.trim() || '';
      return selected.getAttribute('data-value') || selected.getAttribute('data-val') || selected.getAttribute('data-name') || selected.getAttribute('data-text') || selected.textContent.trim();
    }
    const checked = wrapper.querySelector('input:checked');
    return checked?.value || '';
  }
  // Default background for each motif (same mapping as product 16093135176067).
  const MOTIF_TO_COLOR = {
    'Schmetterling':'Lila', 'schmetterling-02':'Lila',
    'einhörnchen':'Lila', 'Bellerina':'Lila', 'Bellerina-2':'Lila',
    'Blume':'Lila', 'Meerjungfrau':'Lila', 'Pferd':'Sandbeige',
    'Katze':'Terrakotta', 'Erdbeere':'Salbeigrün', 'Bär':'Sandbeige',
    'Dino':'Salbeigrün', 'Dino-02':'Sandbeige', 'Traktor':'Salbeigrün',
    'Tiger':'Terrakotta', 'Tiger-02':'Terrakotta', 'Löwe-01':'Buttergelb',
    'Fussball':'Taubenblau', 'Basketball':'Taubenblau',
    'Feuertruck':'Taubenblau', 'Bagger':'Taubenblau',
    'Rakete':'Taubenblau', 'Polizeiauto':'Taubenblau',
    'Biene':'Buttergelb', 'Biene-02':'Buttergelb', 'Sonne':'Buttergelb',
    'Giraffe':'Buttergelb', 'Regenbogen':'Taubenblau',
    'Schildkröte':'Salbeigrün', 'Fuchs':'Terrakotta',
    'Fuchs-02':'Terrakotta', 'Eule-02':'Sandbeige',
    'Igel':'Terrakotta', 'Koala':'Sandbeige', 'Panda-01':'Taubenblau',
    'Panda-03':'Sandbeige', 'Reh':'Sandbeige', 'Hase-01':'Terrakotta',
    'Astronaut':'Lila', 'Regenbogen-02':'Lila', 'Hund':'Sandbeige',
    'Flugzeug':'Terrakotta', 'Roboter':'Sandbeige',
    'Kuh-03':'Salbeigrün', 'Delfin-03':'Taubenblau',
    'Elefant-03':'Lila', 'Pinguin-03':'Taubenblau',
    'Welpe-03':'Sandbeige', 'Einhorn-03':'Lila',
    'Panda-04':'Sandbeige', 'Kein-Motiv':'Sandbeige'
  };
  Object.assign(MOTIF_TO_COLOR, window.BZ_AQ_COLOR || {});
  const normalizeChoice = v => String(v || '').normalize('NFKC').trim().toLocaleLowerCase('de-DE').replace(/[\s_]+/g, '-');
  const colorByMotif = new Map(Object.entries(MOTIF_TO_COLOR).map(([motif, color]) => [normalizeChoice(motif), color]));
  function optionWrapper(root, pattern) {
    return [...root.querySelectorAll('.pplr-wrapper')].find(w =>
      pattern.test(w.querySelector(':scope > .pplrlabel')?.textContent || '') ||
      [...w.classList].some(c => pattern.test(c.replace(/^pplr-/, '')))
    );
  }
  function currentMotif(wrapper) {
    if (!wrapper) return '';
    const selected = wrapper.querySelector('.pplr-drop-item.active, .pplr-swatch-element.selected, .pplr-swatch-element.active, .pplr-swatch-element[aria-selected="true"], .pplr-selecter-item.selected, .pplr-selecter-item.active, [data-value][aria-checked="true"]');
    return selected?.getAttribute('data-value') || selected?.getAttribute('data-val') || selected?.getAttribute('data-name') ||
      wrapper.querySelector('input.pplr_select, input[type="hidden"][name^="properties"], select')?.value || getSelection(wrapper);
  }
  let lastMotif = null;
  let applyingBackground = false;
  function autoBackground() {
    if (applyingBackground) return;
    const root = document.querySelector(rootSelector);
    if (!root) return;
    const motifWrapper = optionWrapper(root, /design\s*wählen|motiv\s*wählen|^motiv$|^design$/i);
    const backgroundWrapper = optionWrapper(root, /hintergrund/i);
    if (!motifWrapper || !backgroundWrapper) return;
    const motif = normalizeChoice(currentMotif(motifWrapper));
    if (!motif || motif === lastMotif) return;
    const targetColor = colorByMotif.get(motif);
    if (!targetColor) return; // Unknown motif: preserve customer's background.
    const options = backgroundWrapper.querySelectorAll('.pplr-drop-item, .pplr-swatch-element, .pplr-selecter-item, [data-value], option');
    const wanted = [...options].find(el =>
      [el.getAttribute('data-value'), el.getAttribute('data-val'), el.getAttribute('data-name'), el.getAttribute('title'), el.getAttribute('aria-label'), el.textContent]
        .some(v => normalizeChoice(v) === normalizeChoice(targetColor))
    );
    if (!wanted) return; // Do not mark as applied until Zepto's color choices exist.
    lastMotif = motif;
    applyingBackground = true;
    try {
      if (wanted.tagName === 'OPTION') {
        const select = wanted.closest('select');
        if (select && select.value !== wanted.value) {
          select.value = wanted.value;
          select.dispatchEvent(new Event('change', {bubbles:true}));
        }
      } else if (!wanted.matches('.active, .selected, [aria-selected="true"]')) {
        wanted.click(); // Use Zepto's native selection handler to update its preview.
      }
    } finally { applyingBackground = false; }
  }
  function scheduleAutoBackground() { setTimeout(autoBackground, 0); }
  function buildSummary() {
    const root = document.querySelector(rootSelector);
    if (!root) return 'Noch keine Auswahl getroffen.';
    const rows = [];
    const wrappers = root.querySelectorAll('.pplr-wrapper');
    wrappers.forEach((wrapper, index) => {
      if (wrapper.classList.contains('pplr-anzahl')) return;
      // Exclude nested wrappers to avoid duplicate fields.
      if (wrapper.parentElement?.closest('.pplr-wrapper')) return;
      const label = wrapper.querySelector(':scope > .pplrlabel')?.textContent?.trim().replace(/\s+/g,' ') || wrapper.getAttribute('data-main') || 'Option ' + (index + 1);
      let value = getSelection(wrapper);
      // For two-line names, put the second line in parentheses in the Etsy
      // personalization text only. Leave the actual Zepto input unchanged.
      if (value && /(?:name|namen|wunschtext)/i.test(label)) {
        const lines = value.split(/\r\n|\n|\r/).map(line => line.trim()).filter(Boolean);
        if (lines.length > 1) value = lines[0] + ' (' + lines.slice(1).join(' ') + ')';
      }
      if (value) rows.push(label + ': ' + value);
    });
    return rows.length ? rows.join(' | ') : 'Noch keine Auswahl getroffen.';
  }
  function placeSummaryAtBottom() {
    const box = document.getElementById('buntify-etsy-summary');
    const main = document.querySelector('main#MainContent') || document.querySelector('main');
    if (box && main && box.parentElement !== main) main.appendChild(box);
    else if (box && main && main.lastElementChild !== box) main.appendChild(box);
  }
  function hideExtras() {
    // Remove the sticky purchase bar, including its custom element host if present.
    document.querySelectorAll('.sticky-add-to-cart__bar, sticky-add-to-cart, .sticky-add-to-cart').forEach(el => {
      el.style.setProperty('display', 'none', 'important');
    });
    // Judge.me's outer Shopify section can reserve a large blank area even
    // when the review widget itself is hidden. Hide only the dedicated section.
    document.querySelectorAll('[id^="shopify-block-"][id*="judge_me_reviews_review_widget"], #judgeme_product_reviews').forEach(el => {
      const section = el.closest('.shopify-section, section[id^="shopify-section-"]');
      if (section && section !== document.querySelector('main') && !section.querySelector(rootSelector)) {
        section.style.setProperty('display', 'none', 'important');
        section.style.setProperty('min-height', '0', 'important');
        section.style.setProperty('padding', '0', 'important');
        section.style.setProperty('margin', '0', 'important');
      } else {
        const wrapper = el.closest('[data-testid="section-content"]');
        if (wrapper && !wrapper.querySelector(rootSelector)) {
          wrapper.style.setProperty('display', 'none', 'important');
        }
      }
    });
    // Zepto quantity remains internally selected, but is not shown to Etsy shoppers.
    document.querySelectorAll('.pplr-wrapper.pplr-anzahl').forEach(el => el.style.setProperty('display','none','important'));
    // Hide product detail jump control, not the entire product information panel.
    document.querySelectorAll('a[href*="#bf-spec-details"]').forEach(el => {
      const parent = el.closest('button') || el;
      parent.style.setProperty('display','none','important');
    });
    document.querySelectorAll('img[src*="mig2.png"]').forEach(img => {
      const parent = img.closest('a') || img;
      parent.style.setProperty('display','none','important');
    });
    // Hide only the extra storefront blocks on this Etsy-only product.
    document.querySelectorAll('a[href*="wa.me/"]').forEach(a => {
      const block = a.closest('div[style*="text-align:center"]');
      if (block) block.style.setProperty('display', 'none', 'important');
    });
    document.querySelectorAll('accordion-custom').forEach(el => {
      const title = el.querySelector('summary')?.textContent?.replace(/\s+/g, ' ').trim();
      if (title === 'Anleitung' || title === 'Fragen und Antworten') el.style.setProperty('display', 'none', 'important');
    });
    // Klarna promotional image, without affecting the actual product imagery.
    document.querySelectorAll('img').forEach(img => {
      if (/klarna/i.test([img.alt, img.src].join(' '))) {
        const container = img.closest('div') || img;
        container.style.setProperty('display', 'none', 'important');
      }
    });
  }

  // Motif categories copied from the primary Buntify personalizer (16093135176067).
  const BESTSELLERS = ['Meerjungfrau','Löwe-01','Tiger','Tiger-02','Schmetterling','schmetterling-02','Bellerina','Bellerina-2','Eule-02','Katze','Hase-01','Polizeiauto','Bagger','Fuchs-02','Fuchs','Kuh-03','Delfin-03','Elefant-03','Panda-04','Pinguin-03','Welpe-03','Einhorn-03'];
  const MOTIF_CATEGORIES = [
    {label:'🎨 Aquarell ✨ Neu',id:'bestseller',motifs:window.BZ_AQ_ORDER},
    {label:'🐾 Tiere',id:'tiere',motifs:['Bär','Fuchs','Fuchs-02','Tiger','Tiger-02','Giraffe','Löwe-01','Loewe-02','Pferd','Katze','Katze-01','Hund','Hund-01','Reh','Reh-01','Hase-01','Igel','Koala','Panda-01','Panda-03','Schildkroete-01','Schildkröte','Dino','Dino-02','Eule-02','Eule-2','Biene','Biene-02','Marienkaefer','Schmetterling','schmetterling-02','einhörnchen','Kuh-03','Delfin-03','Elefant-03','Pinguin-03','Welpe-03','Einhorn-03','Panda-04']},
    {label:'✨ Fantasie & Sport',id:'fantasie',motifs:['Bellerina','Bellerina-2','Meerjungfrau','Blume','Erdbeere','Sonne','Regenbogen','Regenbogen-02','Fussball','Basketball']},
    {label:'🚀 Fahrzeuge & Space',id:'fahrzeuge',motifs:['Traktor','Feuertruck','Bagger','Rakete','Polizeiauto','Astronaut','Flugzeug','Roboter']}
  ];
  function setupMotifTabs(root) {
    const wrapper = root.querySelector('[data-main="1"]');
    const grid = wrapper?.querySelector('.pplrgcolor.pplr_thumb_image.pplr-swatch-main');
    if (!grid || grid.dataset.buntifyTabsReady === '1') return;
    const swatches = [...grid.querySelectorAll('.pplr-swatch-element.pplrimage')];
    if (!swatches.length) return;
    grid.dataset.buntifyTabsReady = '1';
    const normalize = str => String(str || '').toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g,'').replace(/[\s_]+/g,'-').trim();
    const known = new Set(MOTIF_CATEGORIES.flatMap(c=>c.motifs).map(normalize));
    const extra = swatches.map(s=>s.getAttribute('data-val')||'').filter(v=>v && !known.has(normalize(v)) && normalize(v)!=='kein-motiv');
    const vals = new Set(swatches.map(s=>normalize(s.getAttribute('data-val'))));
    const categories = (extra.length ? [...MOTIF_CATEGORIES,{label:'Weitere',id:'weitere',motifs:extra}] : MOTIF_CATEGORIES).filter(c=>c.motifs.some(m=>vals.has(normalize(m))));
    if (!categories.length) return;
    const bar = document.createElement('div'); bar.className='buntify-motif-tabs';
    const buttons=[];
    function forceImage(swatch) {
      const url=swatch.getAttribute('data-image')||swatch.getAttribute('data-thumb');
      if (!url || swatch.dataset.buntifyImgForced===url || swatch.dataset.buntifyImgLoading===url) return;
      if (getComputedStyle(swatch).display==='none') return; // hidden tab: load when shown
      swatch.dataset.buntifyImgLoading=url;
      let src=window.bzThumb?window.bzThumb(url,160):url;
      const img=new Image();
      img.onerror=()=>{if(src!==url){src=url;img.crossOrigin='anonymous';img.src=url;}};
      img.onload=()=>{swatch.style.setProperty('background-image',`url("${src.replace(/"/g,'\\"')}")`,'important');swatch.style.setProperty('background-size','contain','important');swatch.style.setProperty('background-position','center','important');swatch.style.setProperty('background-repeat','no-repeat','important');swatch.dataset.buntifyImgForced=url;};
      if(src===url)img.crossOrigin='anonymous';
      img.src=src;
    }
    function filter(category) {
      const allowed=new Set(category.motifs.map(normalize));
      for(const swatch of swatches){
        const val=normalize(swatch.getAttribute('data-val'));
        const show=allowed.has(val)||val==='kein-motiv'||swatch.classList.contains('selected')||swatch.classList.contains('active');
        swatch.style.setProperty('display',show?'flex':'none','important');
        if(show) forceImage(swatch);
      }
    }
    for(const category of categories){
      const button=document.createElement('button');button.type='button';button.className='buntify-motif-tab'+(category.id==='bestseller'?' buntify-motif-tab--bestseller':'');button.textContent=category.label;
      button.addEventListener('click',()=>{buttons.forEach(b=>{b.classList.remove('is-active');b.setAttribute('aria-pressed','false');});button.classList.add('is-active');button.setAttribute('aria-pressed','true');filter(category);});
      bar.appendChild(button);buttons.push(button);
    }
    grid.parentNode.insertBefore(bar,grid);
    buttons[0].click(); // shows the first tab and loads only its images
    setTimeout(()=>swatches.forEach(forceImage),500);
    setTimeout(()=>swatches.forEach(forceImage),1500);
  }
  function init() {
    hideExtras();
    const root = document.querySelector(rootSelector);
    if (!root) return;
    setupMotifTabs(root);
    // Zepto renders its swatches after page load: keep retrying until the tabs exist.
    if (!root.querySelector('.buntify-motif-tabs')) {
      const tabsObserver = new MutationObserver(() => {
        setupMotifTabs(root);
        if (root.querySelector('.buntify-motif-tabs')) tabsObserver.disconnect();
      });
      tabsObserver.observe(root, {childList:true, subtree:true});
      let tries = 0;
      const tabsTimer = setInterval(() => {
        setupMotifTabs(root);
        if (root.querySelector('.buntify-motif-tabs') || ++tries > 60) { clearInterval(tabsTimer); tabsObserver.disconnect(); }
      }, 500);
    }
    if (document.getElementById('buntify-etsy-summary')) { placeSummaryAtBottom(); return; }
    const box = document.createElement('section');
    box.id = 'buntify-etsy-summary';
    box.innerHTML = '<h2>Deine Auswahl für Etsy</h2><p>Deine Auswahl kopieren oder eine Designvorschau als PNG herunterladen.</p><div class="selection-row"><input type="text" data-etsy-selection readonly aria-label="Personalisierung für Etsy"><button type="button" data-copy aria-label="Auswahl kopieren" title="Auswahl kopieren"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="8" y="8" width="12" height="12" rx="2"/><path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2"/></svg></button></div><button type="button" data-download>Design herunterladen (PNG)</button><button type="button" class="secondary" data-return>Zurück zu Etsy</button><p class="status" role="status" aria-live="polite"></p>';
    // Bottom of main content, after the product/configurator, before the hidden footer.
    (document.querySelector('main#MainContent') || document.querySelector('main') || root.parentElement).appendChild(box);
    const output = box.querySelector('[data-etsy-selection]');
    const status = box.querySelector('.status');
    let previous = '';
    function refresh() {
      const next = buildSummary();
      if (next !== previous) { output.value = next; previous = next; }
    }
    box.querySelector('[data-copy]').addEventListener('click', async () => {
      refresh();
      try {
        if (navigator.clipboard && window.isSecureContext) await navigator.clipboard.writeText(output.value);
        else { output.focus(); output.select(); if (!document.execCommand('copy')) throw new Error('copy failed'); }
        status.textContent = 'Auswahl kopiert.';
      } catch (error) { output.focus(); output.select(); status.textContent = 'Bitte den markierten Text manuell kopieren.'; }
    });
    // Zepto may render its design in a canvas OR an image. Prefer the canvas,
    // but fall back to the actual preview image if its canvas is unavailable.
    // Cross-origin protected images cannot be exported by client-side JS.
    // ---- Preview export -------------------------------------------------------------
    const inSummary = el => !!el.closest('#buntify-etsy-summary');
    const areaOf = el => (el.width || el.naturalWidth || 0) * (el.height || el.naturalHeight || 0);
    function isClean(canvas) {
      try { const c = canvas.getContext('2d'); if (!c) return false; c.getImageData(0, 0, 1, 1); return true; }
      catch (e) { return false; }
    }
    function findPreview() {
      const wrappers = [...document.querySelectorAll('.pplr_preview_wrapper, .product-media.pplr')];
      const score = el => (el.id === 'pplr_canvas' ? 2e12 : 0) + (wrappers.some(w => w.contains(el)) ? 1e12 : 0) + areaOf(el);
      const canvases = [...document.querySelectorAll('canvas')]
        .filter(el => el.width > 1 && el.height > 1 && !inSummary(el) && !el.classList.contains('upper-canvas'))
        .sort((a, b) => score(b) - score(a));
      // The unpersonalised product photo must never be exported as "the design".
      const featured = String(window.pplr_product?.featured_image || '').split('?')[0].split('/').pop();
      const images = wrappers.flatMap(w => [...w.querySelectorAll('img')])
        .filter(el => el.complete && el.naturalWidth > 1 && !inSummary(el) &&
          !(featured && (el.currentSrc || el.src).includes(featured)))
        .sort((a, b) => areaOf(b) - areaOf(a));
      return { canvases, image: images[0], images };
    }
    function watermarked(source) {
      // naturalWidth first: img.width is the displayed size, not the real one.
      const w = source.naturalWidth || source.width;
      const h = source.naturalHeight || source.height;
      const out = document.createElement('canvas');
      out.width = w; out.height = h;
      const ctx = out.getContext('2d');
      if (!ctx) throw new Error('Canvas nicht verfügbar');
      ctx.drawImage(source, 0, 0, w, h);
      const fontSize = Math.max(16, Math.round(Math.min(w, h) * 0.05));
      ctx.save(); ctx.translate(w / 2, h / 2); ctx.rotate(-Math.PI / 6);
      ctx.font = '700 ' + fontSize + 'px Arial, sans-serif';
      ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.lineWidth = Math.max(2, fontSize * 0.08);
      ctx.strokeStyle = 'rgba(255,255,255,0.35)';
      ctx.fillStyle = 'rgba(40,40,40,0.28)';
      const label = 'Auf Etsy hochladen';
      const stepX = Math.max(ctx.measureText(label).width + fontSize * 2, w * 0.36);
      const stepY = Math.max(fontSize * 3.6, h * 0.18);
      const diagonal = Math.hypot(w, h) * 1.5;
      for (let y = -diagonal; y <= diagonal; y += stepY)
        for (let x = -diagonal; x <= diagonal; x += stepX) {
          ctx.strokeText(label, x, y);
          ctx.fillText(label, x, y);
        }
      ctx.restore();
      return out;
    }
    async function loadExportableImage(image) {
      if (!image) throw new Error('Kein Vorschaubild');
      const src = image.currentSrc || image.src;
      const sameOrigin = src.startsWith('data:') || src.startsWith('blob:') ||
        new URL(src, location.href).origin === location.origin;
      if (sameOrigin) return image;
      const res = await fetch(src, { mode: 'cors', cache: 'reload', credentials: 'omit' });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return await createImageBitmap(await res.blob());
    }
    // Last-resort export for cross-origin Zepto canvases: capture the visible tab.
    // The browser explicitly asks the customer to share the current tab; no data is uploaded.
    async function captureVisiblePreview() {
      if (!navigator.mediaDevices?.getDisplayMedia) throw new Error('Tab-Aufnahme wird von diesem Browser nicht unterstützt');
      const element = findPreview().canvases[0] || document.querySelector('#pplr_canvas') ||
        document.querySelector('.pplr_preview_wrapper canvas') ||
        document.querySelector('.pplr_preview_wrapper');
      if (!element) throw new Error('Zepto-Vorschau nicht gefunden');
      element.scrollIntoView({block:'center',behavior:'instant'});
      await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
      const rect = element.getBoundingClientRect();
      const stream = await navigator.mediaDevices.getDisplayMedia({video:{displaySurface:'browser'},audio:false,preferCurrentTab:true,selfBrowserSurface:'include'});
      try {
        const track = stream.getVideoTracks()[0];
        const settings = track.getSettings();
        if (settings.displaySurface && settings.displaySurface !== 'browser') throw new Error('Bitte diesen Browser-Tab auswählen, nicht den Bildschirm oder ein Fenster');
        const video = document.createElement('video');
        video.muted = true; video.playsInline = true; video.srcObject = stream;
        await video.play();
        await new Promise(resolve => setTimeout(resolve, 350));
        const frame = document.createElement('canvas');
        const sx = video.videoWidth / window.innerWidth;
        const sy = video.videoHeight / window.innerHeight;
        frame.width = Math.max(1, Math.round(rect.width * sx));
        frame.height = Math.max(1, Math.round(rect.height * sy));
        const ctx = frame.getContext('2d');
        ctx.drawImage(video, Math.round(rect.left*sx),Math.round(rect.top*sy),frame.width,frame.height,0,0,frame.width,frame.height);
        return frame;
      } finally {stream.getTracks().forEach(track => track.stop());}
    }
    async function canvasBlob(canvas) {
      return await new Promise((resolve,reject) => {
        try {canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error('PNG-Konvertierung fehlgeschlagen')), 'image/png');}
        catch (error) {reject(error);}
      });
    }
    async function downloadDesign() {
      const button = box.querySelector('[data-download]');
      button.disabled = true;
      status.textContent = 'PNG wird erstellt …';
      const errors = [];
      try {
        const found = findPreview();
        console.info('Buntify export debug:', {
          canvases: found.canvases.map(c => ({ id: c.id, cls: c.className, w: c.width, h: c.height, clean: isClean(c) })),
          images: found.images.map(i => ({ src: i.currentSrc || i.src, w: i.naturalWidth, h: i.naturalHeight }))
        });
        const candidates = [];
        const cleanCanvas = found.canvases.find(isClean);
        if (cleanCanvas) candidates.push(['Canvas', async () => cleanCanvas]);
        // Image fallback only when there is no canvas at all (a single layer is not the full design).
        if (!found.canvases.length && found.image) candidates.push(['Bild', () => loadExportableImage(found.image)]);
        let blob;
        for (const [name, getSource] of candidates) {
          try { blob = await canvasBlob(watermarked(await getSource())); break; }
          catch (error) { errors.push(name + ': ' + error.message); }
        }
        if (!blob) {
          if (found.canvases.length && !cleanCanvas) errors.push('Vorschau-Canvas durch fremde Bilder blockiert (CORS)');
          if (!found.canvases.length && !found.image) errors.push('keine Vorschau gefunden');
          const reason = errors.join('; ') || 'unbekannt';
          if (!navigator.mediaDevices?.getDisplayMedia)
            throw new Error('Auf diesem Gerät nicht möglich – bitte einen Screenshot der Vorschau machen. (' + reason + ')');
          status.textContent = 'Die Vorschau ist geschützt. Bitte im Browser „Diesen Tab“ auswählen und „Teilen“ bestätigen.';
          try { blob = await canvasBlob(watermarked(await captureVisiblePreview())); }
          catch (error) { throw new Error('Tab-Aufnahme fehlgeschlagen: ' + error.message + ' (' + reason + ')'); }
        }
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url; anchor.download = 'Buntify-Design-Vorschau.png';
        box.appendChild(anchor); anchor.click(); anchor.remove();
        setTimeout(() => URL.revokeObjectURL(url), 60000);
        status.textContent = 'Designvorschau heruntergeladen.';
      } catch (error) {
        console.warn('Buntify PNG export:', error, errors);
        status.textContent = 'PNG-Export nicht möglich: ' + error.message;
      } finally { button.disabled = false; }
    }
    box.querySelector('[data-download]').addEventListener('click', downloadDesign);
    box.querySelector('[data-return]').addEventListener('click', () => location.assign(allowedReturn));
    root.addEventListener('input', refresh);
    root.addEventListener('change', scheduleAutoBackground);
    root.addEventListener('click', scheduleAutoBackground);
    root.addEventListener('change', refresh);
    root.addEventListener('click', () => setTimeout(refresh, 0));
    new MutationObserver(() => {refresh(); scheduleAutoBackground();}).observe(root, {subtree:true,attributes:true,attributeFilter:['class','aria-selected','data-value','data-val','data-name']});
    scheduleAutoBackground();
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', () => {hideExtras(); placeSummaryAtBottom();});
  // Re-hide theme/app elements inserted after page load without observing the entire DOM.
  const extrasObserver = new MutationObserver(() => {hideExtras();});
  extrasObserver.observe(document.body || document.documentElement, {childList:true,subtree:true});
  const startup = new MutationObserver(() => {if (document.querySelector(rootSelector)) {init();startup.disconnect();}});
  if (!document.querySelector(rootSelector)) startup.observe(document.documentElement,{childList:true,subtree:true});
})();


/* ============================================================
   BUNTIFY – STIFTEAUFKLEBER: FIT STATIC GALLERY TO PREVIEW (MOBILE)
   Product: 16177787339139
   ============================================================ */
(function () {
  "use strict";

  var PRODUCT_ID = "16177787339139";
  if (!window.bzOn(PRODUCT_ID)) return;
  var MOBILE_QUERY = "(max-width: 749px)";

  var currentId =
    (window.ShopifyAnalytics &&
      window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.product &&
      String(window.ShopifyAnalytics.meta.product.id)) ||
    (window.meta && window.meta.product && String(window.meta.product.id)) ||
    null;

  if (currentId !== PRODUCT_ID) return;

  var frame = 0;

  function getStaticCanvas() {
    var list = document.querySelectorAll("canvas#pplr_canvas, .pplr_preview_wrapper canvas");
    for (var i = 0; i < list.length; i++) {
      if (!list[i].closest(".pplrabs")) return list[i];
    }
    return null;
  }

  function resetGallery(gallery) {
    ["height", "min-height", "max-height", "aspect-ratio", "overflow"].forEach(function (prop) {
      gallery.style.removeProperty(prop);
    });
  }

  function fitGallery() {
    frame = 0;

    var canvas = getStaticCanvas();
    if (!canvas) return;

    var gallery = canvas.closest("media-gallery");
    if (!gallery) return;

    if (!window.matchMedia(MOBILE_QUERY).matches) {
      resetGallery(gallery);
      return;
    }

    var canvasRect = canvas.getBoundingClientRect();
    if (canvasRect.height < 20) return;

    var galleryRect = gallery.getBoundingClientRect();
    var needed = Math.ceil(canvasRect.bottom - galleryRect.top);
    if (needed < 20) return;

    gallery.style.setProperty("height", needed + "px", "important");
    gallery.style.setProperty("min-height", "0", "important");
    gallery.style.setProperty("max-height", "none", "important");
    gallery.style.setProperty("aspect-ratio", "auto", "important");
    gallery.style.setProperty("overflow", "hidden", "important");
  }

  function schedule() {
    if (frame) return;
    frame = window.requestAnimationFrame(fitGallery);
  }

  function start() {
    schedule();

    window.addEventListener("resize", schedule, { passive: true });
    window.addEventListener("orientationchange", schedule, { passive: true });
    window.addEventListener("load", schedule);

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(schedule);
      var attach = function () {
        var c = getStaticCanvas();
        if (c && !c.getAttribute("data-buntify-fit")) {
          c.setAttribute("data-buntify-fit", "1");
          ro.observe(c);
        }
      };
      attach();
      new MutationObserver(function () { attach(); schedule(); })
        .observe(document.body, { childList: true, subtree: true });
    } else {
      window.setTimeout(schedule, 500);
      window.setTimeout(schedule, 1500);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();


/* ============================================================
   BUNTIFY – NAMENSAUFKLEBER: MOTIV-TABS + MUSTER + ZEICHENZÄHLER
   Product: 16093135176067
   (replaces the old "MOTIF CATEGORY TABS + FORCE IMAGE LOAD" block)
   ============================================================ */
(function () {
  "use strict";

  var PRODUCT_ID = "16093135176067";
  if (!window.bzOn(PRODUCT_ID)) return;
  var ROOT_SELECTOR = "#pplr-" + PRODUCT_ID;
  var M = { design: "1", muster: "4", name: "6" };

  /* ---------- CSS: Zeichenzähler + Muster ---------- */
  (function injectCss() {
    if (document.getElementById("buntify-na-fix-css")) return;
    var R = ROOT_SELECTOR;
    var css = [
      /* 0 / 30 counter: above the textarea, right-aligned */
      R + ' .pplr-field-box{display:flex!important;flex-direction:column!important;align-items:stretch!important;width:100%!important;position:relative!important;margin:0!important;padding:0!important}',
      R + ' .pplr-field-box .pplr-character-count{position:static!important;display:block!important;order:-1!important;align-self:flex-end!important;float:none!important;margin:0 0 6px!important;padding:0!important;font-size:12px!important;line-height:1.2!important;color:#8a94a3!important;background:transparent!important;text-align:right!important}',
      R + ' .pplr-field-box textarea.pplr_text{display:block!important;width:100%!important;box-sizing:border-box!important;margin:0!important}',

      /* Muster auswählen */
      R + ' .buntify-muster-title{display:block!important;margin:6px 0 10px!important;font-size:14px!important;font-weight:700!important;line-height:1.35!important;color:#1a1a1a!important}',
      R + ' [data-main="' + M.muster + '"] .pplr-swatch-main{display:flex!important;flex-wrap:wrap!important;gap:10px!important;justify-content:flex-start!important}',
      R + ' [data-main="' + M.muster + '"] .pplr-swatch-element.pplrimage{display:flex!important;visibility:visible!important;opacity:1!important;box-sizing:border-box!important;border:2px solid #e0e0e0!important;border-radius:50%!important;background-color:#fff!important;background-size:contain!important;background-position:center!important;background-repeat:no-repeat!important;cursor:pointer!important}',
      R + ' [data-main="' + M.muster + '"] .pplr-swatch-element.pplrimage.selected{border-color:#5B9BD5!important;box-shadow:0 0 0 3px rgba(91,155,213,.25)!important}',

      /* "Alle Motive anzeigen" at the end of the Lieblingsdesigns tab */
      R + ' .buntify-motif-allwrap{display:flex!important;justify-content:center!important;width:100%!important;margin:14px 0 4px!important}',
      R + ' .buntify-motif-allwrap[hidden]{display:none!important}',
      R + ' button.buntify-motif-all{display:inline-flex!important;align-items:center!important;justify-content:center!important;min-height:44px!important;width:auto!important;padding:10px 22px!important;border:1.5px solid #5B9BD5!important;border-radius:999px!important;background:#fff!important;color:#2f6fae!important;font-size:15px!important;font-weight:600!important;line-height:1.2!important;cursor:pointer!important;box-shadow:none!important}',
      R + ' button.buntify-motif-all:hover{background:#f1f7fc!important}'
    ].join("\n");
    
    var style = document.createElement("style");
    style.id = "buntify-na-fix-css";
    style.textContent = css;
    document.head.appendChild(style);
  })();

  /* ---------- Motiv-Kategorien ---------- */
  var BESTSELLER_MOTIFS = [
    "Meerjungfrau", "Löwe-01", "Tiger", "Tiger-02",
    "Schmetterling", "schmetterling-02",
    "Bellerina", "Bellerina-2", "Eule-02",
    "Katze", "Hase-01", "Polizeiauto", "Bagger", "Fuchs-02", "Fuchs",
    "Kuh-03", "Delfin-03", "Elefant-03", "Panda-04", "Pinguin-03", "Welpe-03", "Einhorn-03"
  ];

  var CATEGORIES = [
    { id: "bestseller", label: "❤️ Lieblingsdesigns", className: "buntify-motif-tab--bestseller",
      // Aquarell motifs first, then these at the bottom of the tab
      motifs: (window.BZ_AQ_ORDER || []).concat(["Löwe-01", "Meerjungfrau", "Bellerina-2", "Bellerina", "schmetterling-02",
               "Einhorn-03", "Fuchs-02", "Pinguin-03", "Panda-04", "Igel", "Bagger", "Traktor"]) },
    { id: "tiere", label: "🐾 Tiere", motifs: [
        "Bär","Fuchs","Fuchs-02","Tiger","Tiger-02","Giraffe","Löwe-01","Loewe-02","Pferd","Katze","Katze-01",
        "Hund","Hund-01","Reh","Reh-01","Hase-01","Igel","Koala","Panda-01","Panda-03","Schildkroete-01",
        "Schildkröte","Dino","Dino-02","Eule-02","Eule-2","Biene","Biene-02","Marienkaefer","Schmetterling","schmetterling-02","einhörnchen",
        "Kuh-03","Delfin-03","Elefant-03","Pinguin-03","Welpe-03","Einhorn-03","Panda-04"
    ]},
    { id: "fantasie", label: "✨ Fantasie & Sport", motifs: [
        "Bellerina","Bellerina-2",
        "Meerjungfrau","Blume","S-Blume-2","Erdbeere","Sonne","Regenbogen","Regenbogen-02",
        "Fussball","Basketball"
    ]},
    { id: "fahrzeuge", label: "🚀 Fahrzeuge & Space", motifs: [
        "Traktor","Feuertruck","Bagger","Rakete","Polizeiauto","Astronaut","Flugzeug","Roboter"
    ]}
  ];

  var ALWAYS_VISIBLE = ["Kein-Motiv"];

  function normalize(str) {
    return (str || "").toLowerCase().replace(/[\s_]+/g, "-").trim();
  }

  function buildLookup(list) {
    var set = {};
    list.forEach(function (m) { set[normalize(m)] = true; });
    return set;
  }

  function forceLoadImage(swatch) {
    var url = swatch.getAttribute("data-image") || swatch.getAttribute("data-thumb");
    if (!url) return;
    if (swatch.getAttribute("data-buntify-img-forced") === url) return;

    // Swatch shows a small copy (Shopify CDN, ~10 KB instead of up to 400 KB). Zepto still uses the
    // full image for the live preview. If the small copy is missing, fall back to the original.
    var src = window.bzThumb ? window.bzThumb(url, 160) : url;
    var img = new Image();
    if (src === url) {
      // Same CORS mode as Zepto's own canvas image requests; a plain (non-CORS) preload can be
      // reused from cache by Zepto and then makes its live preview canvas fail on the first click.
      img.crossOrigin = "anonymous";
    }
    img.onerror = function () { if (src !== url) { src = url; img.crossOrigin = "anonymous"; img.src = url; } };
    img.onload = function () {
      swatch.style.setProperty("background-image", 'url("' + src.replace(/"/g, '\\"') + '")', "important");
      swatch.style.setProperty("background-position", "center center", "important");
      swatch.style.setProperty("background-size", "contain", "important");
      swatch.style.setProperty("background-repeat", "no-repeat", "important");
      swatch.setAttribute("data-buntify-img-forced", url);
    };
    img.src = src;
  }

  function forceLoadAll(grid) {
    Array.prototype.forEach.call(
      grid.querySelectorAll(".pplr-swatch-element.pplrimage"),
      forceLoadImage
    );
  }

  function filterGrid(grid, category) {
    var swatches = grid.querySelectorAll(".pplr-swatch-element.pplrimage");
    var alwaysSet = buildLookup(ALWAYS_VISIBLE);
    var catSet = buildLookup(category.motifs);
    var pos = {};
    category.motifs.forEach(function (m, i) { var k = normalize(m); if (!(k in pos)) pos[k] = i; });

    Array.prototype.forEach.call(swatches, function (swatch) {
      var norm = normalize(swatch.getAttribute("data-val"));
      var show = alwaysSet[norm] || catSet[norm];
      // show motifs in the order of the list ("Kein Motiv" last)
      swatch.style.setProperty("order", alwaysSet[norm] ? "9999" : String(norm in pos ? pos[norm] : 9000), "important");
      swatch.style.setProperty("display", show ? "flex" : "none", "important");
      if (show) forceLoadImage(swatch);
    });
  }

  function buildTabs(grid, categories) {
    var tabBar = document.createElement("div");
    tabBar.className = "buntify-motif-tabs";
    var buttons = [];

    // "Alle Motive anzeigen": at the end of the Lieblingsdesigns tab, shows every motif in one grid
    var allMotifs = [];
    categories.forEach(function (c) { allMotifs = allMotifs.concat(c.motifs); });
    var allWrap = document.createElement("div");
    allWrap.className = "buntify-motif-allwrap";
    var allBtn = document.createElement("button");
    allBtn.type = "button";
    allBtn.className = "buntify-motif-all";
    allWrap.appendChild(allBtn);
    var showingAll = false;
    function setAllButton(cat) {
      allWrap.hidden = cat !== categories[0];
      allBtn.textContent = showingAll ? "\u2212 Weniger Motive" : "+ Alle Motive anzeigen";
      allBtn.setAttribute("aria-expanded", showingAll ? "true" : "false");
    }
    allBtn.addEventListener("click", function () {
      showingAll = !showingAll;
      filterGrid(grid, showingAll ? { motifs: allMotifs } : categories[0]);
      setAllButton(categories[0]);
      if (!showingAll) tabBar.scrollIntoView({ behavior: "smooth", block: "nearest" });
    });

    categories.forEach(function (cat) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "buntify-motif-tab" + (cat.className ? " " + cat.className : "");
      btn.textContent = cat.label;
      btn.addEventListener("click", function () {
        buttons.forEach(function (b) { b.classList.remove("is-active"); });
        btn.classList.add("is-active");
        showingAll = false;
        filterGrid(grid, cat);
        setAllButton(cat);
      });
      buttons.push(btn);
      tabBar.appendChild(btn);
    });

    grid.parentNode.insertBefore(tabBar, grid);
    grid.parentNode.insertBefore(allWrap, grid.nextSibling);
    buttons[0].classList.add("is-active");
    filterGrid(grid, categories[0]);
    setAllButton(categories[0]);
  }

  function initMotifTabs(root) {
    var motifWrapper = root.querySelector('[data-main="' + M.design + '"]');
    if (!motifWrapper) return false;

    var grid = motifWrapper.querySelector(".pplrgcolor.pplr_thumb_image.pplr-swatch-main");
    if (!grid) return false;
    if (!grid.querySelector(".pplr-swatch-element.pplrimage")) return false;
    if (grid.getAttribute("data-buntify-tabs-ready") === "1") return true;
    grid.setAttribute("data-buntify-tabs-ready", "1");

    // (no more preloading of ALL motifs: only the visible tab is loaded, see filterGrid)

    // Motifs that exist in Zepto but are in no category -> extra tab "Weitere"
    var known = {};
    ALWAYS_VISIBLE.forEach(function (m) { known[normalize(m)] = true; });
    CATEGORIES.forEach(function (c) { c.motifs.forEach(function (m) { known[normalize(m)] = true; }); });

    var extra = [];
    Array.prototype.forEach.call(grid.querySelectorAll(".pplr-swatch-element.pplrimage"), function (s) {
      var v = s.getAttribute("data-val") || "";
      if (v && !known[normalize(v)]) extra.push(v);
    });

    var categories = CATEGORIES.slice();
    if (extra.length) {
      categories.push({ id: "weitere", label: "Weitere", motifs: extra });
      if (window.console) console.warn("[Buntify Motifs] Tab 'Weitere': " + extra.join(", "));
    }

    // Hide tabs that have no motif in this personalizer (e.g. while Zepto still serves older settings).
    categories = categories.filter(function (c) {
      var set = buildLookup(c.motifs);
      return Array.prototype.some.call(grid.querySelectorAll(".pplr-swatch-element.pplrimage"), function (sw) {
        return set[normalize(sw.getAttribute("data-val"))];
      });
    });
    if (!categories.length) return true;
    buildTabs(grid, categories);

    return true;
  }

  /* ---------- Muster auswählen ---------- */
  function initMuster(root) {
    var wrapper = root.querySelector('[data-main="' + M.muster + '"]');
    if (!wrapper) return false;
    if (!wrapper.querySelector(".pplr-swatch-element.pplrimage")) return false;

    if (!wrapper.querySelector(".buntify-muster-title")) {
      var title = document.createElement("span");
      title.className = "buntify-muster-title";
      title.textContent = "Muster auswählen";
      wrapper.insertBefore(title, wrapper.firstChild);
    }
    return true;
  }

  function initAll() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return false;
    var a = initMotifTabs(root);
    var b = initMuster(root);
    return a && b;
  }

  function start() {
    if (initAll()) return;
    var observer = new MutationObserver(function () {
      if (initAll()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 8000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();

/* ============================================================
   BUNTIFY – STIFTEAUFKLEBER: ACCORDION BOXES + AUTO-FARBE
   Product: 16177787339139
   data-main: 1 Design | 2 Hintergrund | 3 Name | 5 Anzahl
   ============================================================ */
(function () {
  "use strict";

  var PRODUCT_ID = "16177787339139";
  if (!window.bzOn(PRODUCT_ID)) return;
  var ROOT_SELECTOR = "#pplr-" + PRODUCT_ID;

  /* ---------- data-main numbers of this product ---------- */
  var M = { design: "1", color: "2", name: "3", qty: "5" };

  /* ---------- design -> background colour ---------- */
  var MOTIF_TO_COLOR = {
    "Schmetterling": "Lila", "schmetterling-02": "Lila",
    "einhörnchen": "Lila",
    "Bellerina": "Lila", "Bellerina-2": "Lila",
    "S-Blume-2": "Lila", "Blume": "Lila",
    "Meerjungfrau": "Lila",
    "Pferd": "Sandbeige",
    "Katze": "Terrakotta", "Katze-01": "Terrakotta",
    "Erdbeere": "Salbeigrün",
    "Bär": "Sandbeige",
    "Dino": "Salbeigrün", "Dino-02": "Sandbeige",
    "Traktor": "Salbeigrün",
    "Tiger": "Terrakotta", "Tiger-02": "Terrakotta",
    "Löwe-01": "Buttergelb", "Loewe-02": "Buttergelb",
    "Fussball": "Taubenblau",
    "Basketball": "Taubenblau",
    "Feuertruck": "Taubenblau",
    "Bagger": "Taubenblau",
    "Rakete": "Taubenblau",
    "Polizeiauto": "Taubenblau",
    "Biene": "Buttergelb", "Biene-02": "Buttergelb",
    "Marienkaefer": "Terrakotta",
    "Sonne": "Buttergelb",
    "Giraffe": "Buttergelb",
    "Regenbogen": "Taubenblau", "Regenbogen-02": "Lila",
    "Schildkröte": "Salbeigrün", "Schildkroete-01": "Salbeigrün",
    "Fuchs": "Terrakotta", "Fuchs-02": "Terrakotta",
    "Eule-02": "Sandbeige", "Eule-2": "Sandbeige",
    "Igel": "Terrakotta",
    "Koala": "Sandbeige",
    "Panda-01": "Taubenblau", "Panda-03": "Sandbeige", "Panda-04": "Sandbeige",
    "Reh": "Sandbeige", "Reh-01": "Sandbeige",
    "Hase-01": "Terrakotta",
    "Astronaut": "Lila",
    "Hund": "Sandbeige", "Hund-01": "Sandbeige", "Welpe-03": "Sandbeige",
    "Flugzeug": "Terrakotta",
    "Roboter": "Sandbeige",
    "Kuh-03": "Salbeigrün",
    "Delfin-03": "Taubenblau",
    "Elefant-03": "Lila",
    "Pinguin-03": "Taubenblau",
    "Einhorn-03": "Lila",
    "Kein-Motiv": "Sandbeige"
  };
  Object.keys(window.BZ_AQ_COLOR || {}).forEach(function (k) { if (!MOTIF_TO_COLOR[k]) MOTIF_TO_COLOR[k] = window.BZ_AQ_COLOR[k]; });
  var FALLBACK_COLOR = "Sandbeige";
  var NAME_DEBOUNCE = 500;

  var COPY = {
    step1: "1. Design wählen",
    step2: "Hintergrundfarbe anpassen",
    step3: "2. Name eingeben",
    step4: "3. Menge wählen",
    readyHeadline: function (name) {
      return "Individuell gestaltet für " + (name || "dein Kind") +
        " \u2013 jetzt bestellen und in 2\u20133 Werktagen kostenlos erhalten";
    },
    readySub: "Professionell gedruckt & geschnitten in Stuttgart",
  };

  /* ============================================================
     CSS (scoped to this product)
     ============================================================ */
  (function injectCss() {
    if (document.getElementById("buntify-st-css")) return;
    var R = "#pplr-" + PRODUCT_ID;
    var css = [
      R + ' .pplr-choice-label{display:none!important}',
      R + ' .buntify-na-original-label{display:none!important}',
      R + ' .buntify-na-content.is-collapsed{display:none!important}',
      R + ' .buntify-na-content.is-expanded{display:flex!important;flex-direction:column!important;gap:24px!important;padding:14px 14px 16px!important;margin-top:-24px!important;background:#fff!important;border:1.5px solid #9fc4e7!important;border-top:none!important;border-radius:0 0 14px 14px!important;box-sizing:border-box!important}',
      R + ' .buntify-na-trigger{display:flex!important;align-items:center!important;justify-content:space-between!important;gap:14px!important;width:100%!important;min-height:56px!important;box-sizing:border-box!important;margin:0!important;padding:13px 15px!important;appearance:none!important;-webkit-appearance:none!important;background:#f8fbfe!important;border:1.5px solid #dfe8f2!important;border-radius:14px!important;color:#1a1a1a!important;font:inherit!important;font-size:15px!important;font-weight:700!important;text-align:left!important;cursor:pointer!important;outline:none!important;box-shadow:0 2px 10px rgba(27,67,103,.05)!important;-webkit-tap-highlight-color:transparent!important;transition:border-color .18s ease,box-shadow .18s ease,background-color .18s ease!important;pointer-events:auto!important;scroll-margin-top:24px}',
      R + ' .buntify-na-trigger *{pointer-events:none!important}',
      R + ' .buntify-na-trigger:hover,' + R + ' .buntify-na-trigger.is-open{border-color:#9fc4e7!important;background:#f1f7fc!important;box-shadow:0 5px 18px rgba(91,155,213,.13)!important}',
      R + ' .buntify-na-trigger.is-open{border-radius:14px 14px 0 0!important;border-bottom-color:#9fc4e7!important}',
      R + ' .buntify-na-trigger:focus-visible{box-shadow:0 0 0 3px rgba(91,155,213,.22)!important}',
      R + ' .buntify-na-trigger.is-done .buntify-na-trigger__text{color:#2e7d32!important}',
      R + ' .buntify-na-trigger__text{min-width:0!important;line-height:1.35!important;white-space:normal!important}',
      R + ' .buntify-na-trigger__icon{position:relative!important;flex:0 0 28px!important;width:28px!important;height:28px!important;border-radius:50%!important;background:#eaf3fb!important}',
      R + ' .buntify-na-trigger__icon::before,' + R + ' .buntify-na-trigger__icon::after{content:""!important;position:absolute!important;top:50%!important;left:50%!important;width:12px!important;height:2px!important;background:#4f82b2!important;border-radius:999px!important;transform:translate(-50%,-50%)!important;transition:opacity .18s ease!important}',
      R + ' .buntify-na-trigger__icon::after{transform:translate(-50%,-50%) rotate(90deg)!important}',
      R + ' .buntify-na-trigger.is-open .buntify-na-trigger__icon{background:#dcecf9!important}',
      R + ' .buntify-na-trigger.is-open .buntify-na-trigger__icon::after{opacity:0!important}',
    R + ' .pplr-field-box{display:flex!important;flex-direction:column!important;align-items:stretch!important;width:100%!important;position:relative!important;margin:0!important;padding:0!important}',
R + ' .pplr-field-box .pplr-character-count{position:static!important;display:block!important;order:-1!important;align-self:flex-end!important;float:none!important;margin:0 0 6px!important;padding:0!important;font-size:12px!important;line-height:1.2!important;color:#8a94a3!important;background:transparent!important;text-align:right!important}',
R + ' .pplr-field-box textarea.pplr_text{display:block!important;width:100%!important;box-sizing:border-box!important;margin:0!important}',
R + ' .buntify-na-content .pplr-character-count{position:static!important;float:none!important}',
      R + ' #nka-modern{margin:4px 0 14px!important}',
      R + ' .buntify-na-content .pplr_option_price_span:empty{display:none!important}',
      R + ' .pplr-font-select>.pplrlabel,' + R + ' .pplr-color-select>.pplrlabel{display:block!important;margin:0 0 2px!important;color:#1a1a1a!important;font-size:14px!important;font-weight:700!important;line-height:1.35!important}',
      R + ' .pplr-color-select .pplr-swatch-element.pplrColor{width:54px!important;height:54px!important}',
      '.buntify-na-ready{margin:4px 0 14px!important;padding:14px 16px!important;background:#f4f9f4!important;border:1.5px solid #cfe6cf!important;border-radius:14px!important;text-align:left!important}',
      '.buntify-na-ready.is-hidden{display:none!important}',
      '.buntify-na-ready__headline{margin:0 0 4px!important;font-size:15px!important;font-weight:700!important;color:#1a1a1a!important}',
      '.buntify-na-ready__sub{margin:0!important;font-size:13px!important;color:#4b4b4b!important}',
      '@media screen and (max-width:749px){' + R + ' .buntify-na-trigger{scroll-margin-top:220px}}',
      '@media (max-width:768px){' +
        R + ' .buntify-na-trigger{min-height:52px!important;padding:12px 13px!important;font-size:14px!important}' +
        R + ' .buntify-na-content.is-expanded{padding:12px 10px 14px!important}' +
        R + ' .pplr-color-select .pplr-swatch-element.pplrColor{width:50px!important;height:50px!important}' +
        '.buntify-na-ready{padding:12px 14px!important}}'
    ].join("\n");
    var style = document.createElement("style");
    style.id = "buntify-st-css";
    style.textContent = css;
    document.head.appendChild(style);
  })();

  /* ============================================================
     Helpers
     ============================================================ */
  if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";


  function findLabel(wrapper) {
    for (var i = 0; i < wrapper.children.length; i++) {
      if (wrapper.children[i].classList.contains("pplrlabel")) return wrapper.children[i];
    }
    return null;
  }

  function hideOriginalLabel(wrapper) {
    var lbl = findLabel(wrapper);
    if (!lbl) return;
    lbl.classList.add("buntify-na-original-label");
    lbl.removeAttribute("onclick");
  }

  function makeTrigger(text, panelId) {
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "buntify-na-trigger";
    btn.setAttribute("aria-expanded", "false");
    btn.setAttribute("aria-controls", panelId);
    var span = document.createElement("span");
    span.className = "buntify-na-trigger__text";
    span.textContent = text;
    var icon = document.createElement("span");
    icon.className = "buntify-na-trigger__icon";
    icon.setAttribute("aria-hidden", "true");
    btn.appendChild(span);
    btn.appendChild(icon);
    return btn;
  }

  function setOpen(step, open) {
    step.trigger.classList.toggle("is-open", open);
    step.trigger.setAttribute("aria-expanded", open ? "true" : "false");
    step.wrapper.classList.toggle("is-collapsed", !open);
    step.wrapper.classList.toggle("is-expanded", open);
  }

  function setDone(step, summary) {
    step.trigger.querySelector(".buntify-na-trigger__text").textContent =
      "\u2713 " + step.baseLabel + (summary ? ": " + summary : "");
    step.trigger.classList.add("is-done");
  }

  function clearDone(step) {
    step.trigger.querySelector(".buntify-na-trigger__text").textContent = step.baseLabel;
    step.trigger.classList.remove("is-done");
  }

  function scrollToStep(step) {
    step.trigger.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function buildStep(root, dataMain, label, index) {
    var wrapper = root.querySelector('[data-main="' + dataMain + '"]');
    if (!wrapper) return null;
    if (wrapper.getAttribute("data-buntify-na-ready") === "1") return null;
    var originalLabel = findLabel(wrapper);
    if (!originalLabel || !wrapper.parentNode) return null;

    var panelId = "buntify-st-panel-" + index;
    var trigger = makeTrigger(label, panelId);
    trigger.id = "buntify-st-trigger-" + index;

    wrapper.parentNode.insertBefore(trigger, wrapper);
    wrapper.id = panelId;
    wrapper.classList.add("buntify-na-content");
    hideOriginalLabel(wrapper);
    wrapper.setAttribute("data-buntify-na-ready", "1");

    return { wrapper: wrapper, trigger: trigger, baseLabel: label, dataMain: dataMain };
  }

  /* ============================================================
     Main init
     ============================================================ */
  function initAccordion() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return false;
    if (root.getAttribute("data-buntify-st-init") === "1") return true;

    var stepDesign = buildStep(root, M.design, COPY.step1, 1);
    var stepColor  = buildStep(root, M.color,  COPY.step2, 2);
    var stepName   = buildStep(root, M.name,   COPY.step3, 3);
    var stepQty    = buildStep(root, M.qty,    COPY.step4, 4);
    if (!stepDesign || !stepColor || !stepName || !stepQty) return false;

    root.setAttribute("data-buntify-st-init", "1");

    var allSteps = [stepDesign, stepColor, stepName, stepQty];
    var colorManuallySet = false;
    var selectedMotif = null;
    var nameDebounceTimer = null;
    setTimeout(function () { allSteps.forEach(reacquireStep); }, 0);

    function reacquireStep(step) {
      var fresh = root.querySelector('[data-main="' + step.dataMain + '"]');
      if (!fresh) return;
      if (fresh.id !== step.trigger.getAttribute("aria-controls")) {
        fresh.id = step.trigger.getAttribute("aria-controls");
      }
      step.wrapper = fresh;
      if (!fresh.classList.contains("buntify-na-content")) fresh.classList.add("buntify-na-content");
      hideOriginalLabel(fresh);

      var open = step.trigger.getAttribute("aria-expanded") === "true";
      fresh.classList.toggle("is-collapsed", !open);
      fresh.classList.toggle("is-expanded", open);
    }

    new MutationObserver(function () {
      if (window.__bzAdding) return; // pause page tweaks while Zepto adds to cart
      allSteps.forEach(reacquireStep);
    }).observe(root, { childList: true, subtree: true });

    function closeAllExcept(keep) {
      allSteps.forEach(function (s) {
        reacquireStep(s);
        if (s !== keep) setOpen(s, false);
      });
    }

    function goToStep(step) {
      closeAllExcept(step);
      reacquireStep(step);
      setOpen(step, true);
      scrollToStep(step);
    }

    allSteps.forEach(function (step) {
      step.trigger.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        reacquireStep(step);
        var wasOpen = step.trigger.getAttribute("aria-expanded") === "true";
        closeAllExcept(step);
        setOpen(step, !wasOpen);
        if (!wasOpen) scrollToStep(step);
      });
    });

    allSteps.forEach(function (s) { setOpen(s, true); });

    /* ---- ready panel ---- */
    var form = root.closest("form");
    var buyButtons = form && form.querySelector(".product-form-buttons");
    var readyPanel = document.createElement("div");
    readyPanel.className = "buntify-na-ready is-hidden";
    readyPanel.innerHTML =
      '<p class="buntify-na-ready__headline"></p><p class="buntify-na-ready__sub">' + COPY.readySub + "</p>";
    if (buyButtons && buyButtons.parentNode) buyButtons.parentNode.insertBefore(readyPanel, buyButtons);

    function currentNameInput() {
      return root.querySelector('[data-main="' + M.name + '"] input.pplr_text, [data-main="' + M.name + '"] textarea.pplr_text');
    }
    function currentName() {
      var ta = currentNameInput();
      return ta ? ta.value.trim().split("\n")[0] : "";
    }
    function refreshReadyPanel() {
      var name = currentName();
      if (!name) { readyPanel.classList.add("is-hidden"); return; }
      readyPanel.classList.remove("is-hidden");
      readyPanel.querySelector(".buntify-na-ready__headline").textContent = COPY.readyHeadline(name);
    }

    /* ---- design click -> auto colour ---- */
    root.addEventListener("click", function (e) {
      var swatch = e.target.closest(".pplr-swatch-element.pplrimage");
      if (!swatch || !swatch.closest('[data-main="' + M.design + '"]')) return;
      selectedMotif = swatch.getAttribute("data-val");

      window.setTimeout(function () {
        if (!colorManuallySet) {
          var colorName = MOTIF_TO_COLOR[selectedMotif] || FALLBACK_COLOR;
          var colorSwatch = root.querySelector(
            '[data-main="' + M.color + '"] .pplr-swatch-element.pplrColor[data-name="' + colorName + '"]'
          );
          if (colorSwatch) colorSwatch.click();
          setDone(stepColor, colorName);
        }
        setDone(stepDesign, selectedMotif);
      }, 0);
    });

    /* ---- manual background colour ---- */
    root.addEventListener("click", function (e) {
      var swatch = e.target.closest(".pplr-swatch-element.pplrColor");
      if (!swatch || !swatch.closest('[data-main="' + M.color + '"]')) return;
      if (e.isTrusted) colorManuallySet = true;
      setDone(stepColor, swatch.getAttribute("data-name") || "");
    });

    /* ---- name input ---- */
    root.addEventListener("input", function (e) {
      if (!e.target.matches("input.pplr_text, textarea.pplr_text") || !e.target.closest('[data-main="' + M.name + '"]')) return;
      refreshReadyPanel();
      var value = e.target.value.trim();
      if (nameDebounceTimer) window.clearTimeout(nameDebounceTimer);
      if (!value) { clearDone(stepName); return; }
      nameDebounceTimer = window.setTimeout(function () { setDone(stepName, value); }, NAME_DEBOUNCE);
    });

    /* ---- quantity ---- */
    function qtyLabel(active) {
      if (!active) return "";
      var v = (active.getAttribute("data-value") || "").trim();
      return /^\d+$/.test(v) ? v + " Stk." : v;
    }
    function markQty() {
      var active = root.querySelector('[data-main="' + M.qty + '"] .pplr-drop-item.active');
      if (active) setDone(stepQty, qtyLabel(active)); else clearDone(stepQty);
      refreshReadyPanel();
    }

    markQty();

    root.addEventListener("click", function (e) {
      var item = e.target.closest(".pplr-drop-item");
      if (!item || !item.closest('[data-main="' + M.qty + '"]')) return;
      window.setTimeout(markQty, 0);
    });


    /* ---- move "Neukunden Angebot" into Menge step (if present) ---- */
    function moveOffer() {
      var offer = document.getElementById("nka-modern");
      if (!offer) return false;
      if (offer.getAttribute("data-buntify-moved") === "1") return true;
      stepQty.wrapper.appendChild(offer);
      offer.setAttribute("data-buntify-moved", "1");
      return true;
    }
    if (!moveOffer()) {
      var offerObs = new MutationObserver(function () { if (moveOffer()) offerObs.disconnect(); });
      offerObs.observe(document.documentElement, { childList: true, subtree: true });
      window.setTimeout(function () { offerObs.disconnect(); }, 8000);
    }

    return true;
  }

  function start() {
    if (initAccordion()) return;
    var observer = new MutationObserver(function () {
      if (initAccordion()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 8000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();


/* ============================================================
   BUNTIFY – STIFTEAUFKLEBER: MOTIV-TABS (Kategorien)
   Product: 16177787339139
   ============================================================ */
(function () {
  "use strict";

  var PRODUCT_ID = "16177787339139";
  if (!window.bzOn(PRODUCT_ID)) return;
  var ROOT_SELECTOR = "#pplr-" + PRODUCT_ID;
  var M = { design: "1" };

  /* ---------- Motiv-Kategorien ---------- */
  var BESTSELLER_MOTIFS = [
    "Meerjungfrau", "Löwe-01", "Tiger", "Tiger-02",
    "Schmetterling", "schmetterling-02",
    "Bellerina", "Bellerina-2", "Eule-02",
    "Katze", "Hase-01", "Polizeiauto", "Bagger", "Fuchs-02", "Fuchs",
    "Kuh-03", "Delfin-03", "Elefant-03", "Panda-04", "Pinguin-03", "Welpe-03", "Einhorn-03"
  ];

  var CATEGORIES = [
    { id: "bestseller", label: "🎨 Aquarell ✨ Neu", className: "buntify-motif-tab--bestseller", motifs: window.BZ_AQ_ORDER },
    { id: "tiere", label: "🐾 Tiere", motifs: [
        "Bär","Fuchs","Fuchs-02","Tiger","Tiger-02","Giraffe","Löwe-01","Loewe-02","Pferd","Katze","Katze-01",
        "Hund","Hund-01","Reh","Reh-01","Hase-01","Igel","Koala","Panda-01","Panda-03","Schildkroete-01",
        "Schildkröte","Dino","Dino-02","Eule-02","Eule-2","Biene","Biene-02","Marienkaefer","Schmetterling","schmetterling-02","einhörnchen",
        "Kuh-03","Delfin-03","Elefant-03","Pinguin-03","Welpe-03","Einhorn-03","Panda-04"
    ]},
    { id: "fantasie", label: "✨ Fantasie & Sport", motifs: [
        "Bellerina","Bellerina-2",
        "Meerjungfrau","Blume","S-Blume-2","Erdbeere","Sonne","Regenbogen","Regenbogen-02",
        "Fussball","Basketball"
    ]},
    { id: "fahrzeuge", label: "🚀 Fahrzeuge & Space", motifs: [
        "Traktor","Feuertruck","Bagger","Rakete","Polizeiauto","Astronaut","Flugzeug","Roboter"
    ]}
  ];

  var ALWAYS_VISIBLE = ["Kein-Motiv"];

  function normalize(str) {
    return (str || "").toLowerCase().replace(/[\s_]+/g, "-").trim();
  }

  function buildLookup(list) {
    var set = {};
    list.forEach(function (m) { set[normalize(m)] = true; });
    return set;
  }

  function forceLoadImage(swatch) {
    var url = swatch.getAttribute("data-image") || swatch.getAttribute("data-thumb");
    if (!url) return;
    if (swatch.getAttribute("data-buntify-img-forced") === url) return;

    // Swatch shows a small copy (Shopify CDN, ~10 KB instead of up to 400 KB). Zepto still uses the
    // full image for the live preview. If the small copy is missing, fall back to the original.
    var src = window.bzThumb ? window.bzThumb(url, 160) : url;
    var img = new Image();
    if (src === url) {
      // Same CORS mode as Zepto's own canvas image requests; a plain (non-CORS) preload can be
      // reused from cache by Zepto and then makes its live preview canvas fail on the first click.
      img.crossOrigin = "anonymous";
    }
    img.onerror = function () { if (src !== url) { src = url; img.crossOrigin = "anonymous"; img.src = url; } };
    img.onload = function () {
      swatch.style.setProperty("background-image", 'url("' + src.replace(/"/g, '\\"') + '")', "important");
      swatch.style.setProperty("background-position", "center center", "important");
      swatch.style.setProperty("background-size", "contain", "important");
      swatch.style.setProperty("background-repeat", "no-repeat", "important");
      swatch.setAttribute("data-buntify-img-forced", url);
    };
    img.src = src;
  }

  function forceLoadAll(grid) {
    Array.prototype.forEach.call(
      grid.querySelectorAll(".pplr-swatch-element.pplrimage"),
      forceLoadImage
    );
  }

  function filterGrid(grid, category) {
    var swatches = grid.querySelectorAll(".pplr-swatch-element.pplrimage");
    var alwaysSet = buildLookup(ALWAYS_VISIBLE);
    var catSet = buildLookup(category.motifs);

    Array.prototype.forEach.call(swatches, function (swatch) {
      var norm = normalize(swatch.getAttribute("data-val"));
      var show = alwaysSet[norm] || catSet[norm];
      swatch.style.setProperty("display", show ? "flex" : "none", "important");
      if (show) forceLoadImage(swatch);
    });
  }

  function buildTabs(grid, categories) {
    var tabBar = document.createElement("div");
    tabBar.className = "buntify-motif-tabs";
    var buttons = [];

    categories.forEach(function (cat) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "buntify-motif-tab" + (cat.className ? " " + cat.className : "");
      btn.textContent = cat.label;
      btn.addEventListener("click", function () {
        buttons.forEach(function (b) { b.classList.remove("is-active"); });
        btn.classList.add("is-active");
        filterGrid(grid, cat);
      });
      buttons.push(btn);
      tabBar.appendChild(btn);
    });

    grid.parentNode.insertBefore(tabBar, grid);
    buttons[0].classList.add("is-active");
    filterGrid(grid, categories[0]);
  }

  function initMotifTabs(root) {
    var motifWrapper = root.querySelector('[data-main="' + M.design + '"]');
    if (!motifWrapper) return false;

    var grid = motifWrapper.querySelector(".pplrgcolor.pplr_thumb_image.pplr-swatch-main");
    if (!grid) return false;
    if (!grid.querySelector(".pplr-swatch-element.pplrimage")) return false;
    if (grid.getAttribute("data-buntify-tabs-ready") === "1") return true;
    grid.setAttribute("data-buntify-tabs-ready", "1");

    // (no more preloading of ALL motifs: only the visible tab is loaded, see filterGrid)

    // Motifs that exist in Zepto but are in no category -> extra tab "Weitere"
    var known = {};
    ALWAYS_VISIBLE.forEach(function (m) { known[normalize(m)] = true; });
    CATEGORIES.forEach(function (c) { c.motifs.forEach(function (m) { known[normalize(m)] = true; }); });

    var extra = [];
    Array.prototype.forEach.call(grid.querySelectorAll(".pplr-swatch-element.pplrimage"), function (s) {
      var v = s.getAttribute("data-val") || "";
      if (v && !known[normalize(v)]) extra.push(v);
    });

    var categories = CATEGORIES.slice();
    if (extra.length) {
      categories.push({ id: "weitere", label: "Weitere", motifs: extra });
      if (window.console) console.warn("[Buntify Motifs] Tab 'Weitere': " + extra.join(", "));
    }

    // Hide tabs that have no motif in this personalizer (e.g. while Zepto still serves older settings).
    categories = categories.filter(function (c) {
      var set = buildLookup(c.motifs);
      return Array.prototype.some.call(grid.querySelectorAll(".pplr-swatch-element.pplrimage"), function (sw) {
        return set[normalize(sw.getAttribute("data-val"))];
      });
    });
    if (!categories.length) return true;
    buildTabs(grid, categories);

    return true;
  }

  function initAll() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return false;
    return initMotifTabs(root);
  }

  function start() {
    if (initAll()) return;
    var observer = new MutationObserver(function () {
      if (initAll()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 8000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();


/* ============================================================
   BUNTIFY - RESPONSIVE MOTIF LAYOUT & CENTERED MUSTER
   Presentation only: does not change Zepto selection or cart logic.
   ============================================================ */
(function () {
  'use strict';
  if (document.getElementById('buntify-responsive-motif-layout')) return;
  if (window.BZ_PID && ["16093135176067", "16379882635651", "16177787339139", "16382167712131"].indexOf(window.BZ_PID) < 0) return;
  var style = document.createElement('style');
  style.id = 'buntify-responsive-motif-layout';
  style.textContent = `
    /* Let the motif area fill its enclosing option panel. */
    #pplr-16093135176067 [data-main="1"] .pplrgcolor.pplr_thumb_image.pplr-swatch-main,
    #pplr-16379882635651 [data-main="1"] .pplrgcolor.pplr_thumb_image.pplr-swatch-main,
    #pplr-16177787339139 [data-main="1"] .pplrgcolor.pplr_thumb_image.pplr-swatch-main,
    #pplr-16382167712131 [data-main="1"] .pplrgcolor.pplr_thumb_image.pplr-swatch-main {
      display: grid !important;
      width: 100% !important;
      box-sizing: border-box !important;
      grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
      column-gap: 8px !important;
      row-gap: 10px !important;
      align-items: start !important;
      justify-content: stretch !important;
    }
    #pplr-16093135176067 [data-main="1"] .pplrgcolor.pplr_thumb_image.pplr-swatch-main > .pplr-swatch-element.pplrimage,
    #pplr-16379882635651 [data-main="1"] .pplrgcolor.pplr_thumb_image.pplr-swatch-main > .pplr-swatch-element.pplrimage,
    #pplr-16177787339139 [data-main="1"] .pplrgcolor.pplr_thumb_image.pplr-swatch-main > .pplr-swatch-element.pplrimage,
    #pplr-16382167712131 [data-main="1"] .pplrgcolor.pplr_thumb_image.pplr-swatch-main > .pplr-swatch-element.pplrimage {
      width: 100% !important;
      min-width: 0 !important;
      max-width: none !important;
      height: auto !important;
      aspect-ratio: 1 / 1 !important;
      box-sizing: border-box !important;
      background-position: center !important;
      background-size: contain !important;
      margin: 0 !important;
    }
    @media (min-width: 600px) {
      #pplr-16093135176067 [data-main="1"] .pplrgcolor.pplr_thumb_image.pplr-swatch-main,
      #pplr-16379882635651 [data-main="1"] .pplrgcolor.pplr_thumb_image.pplr-swatch-main,
      #pplr-16177787339139 [data-main="1"] .pplrgcolor.pplr_thumb_image.pplr-swatch-main,
      #pplr-16382167712131 [data-main="1"] .pplrgcolor.pplr_thumb_image.pplr-swatch-main {
        grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
        gap: 10px !important;
      }
    }
    @media (min-width: 1100px) {
      #pplr-16093135176067 [data-main="1"] .pplrgcolor.pplr_thumb_image.pplr-swatch-main,
      #pplr-16379882635651 [data-main="1"] .pplrgcolor.pplr_thumb_image.pplr-swatch-main,
      #pplr-16177787339139 [data-main="1"] .pplrgcolor.pplr_thumb_image.pplr-swatch-main,
      #pplr-16382167712131 [data-main="1"] .pplrgcolor.pplr_thumb_image.pplr-swatch-main {
        grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
      }
    }
    /* Center Muster choices as a group, including incomplete last rows. */
    #pplr-16093135176067 [data-main="4"] .pplr-swatch-main,
    #pplr-16379882635651 [data-main="4"] .pplr-swatch-main,
    #pplr-16382167712131 [data-main="4"] .pplr-swatch-main {
      display: grid !important;
      width: 100% !important;
      grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
      justify-items: center !important;
      align-items: center !important;
      gap: 10px !important;
      box-sizing: border-box !important;
    }
    @media (min-width: 600px) {
      #pplr-16093135176067 [data-main="4"] .pplr-swatch-main,
      #pplr-16379882635651 [data-main="4"] .pplr-swatch-main,
      #pplr-16382167712131 [data-main="4"] .pplr-swatch-main {
        grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
      }
    }
    #pplr-16093135176067 [data-main="4"] .pplr-swatch-main > .pplr-swatch-element,
    #pplr-16379882635651 [data-main="4"] .pplr-swatch-main > .pplr-swatch-element,
    #pplr-16382167712131 [data-main="4"] .pplr-swatch-main > .pplr-swatch-element {
      max-width: 100% !important;
      min-width: 0 !important;
      margin-left: auto !important;
      margin-right: auto !important;
    }
  `;
  document.head.appendChild(style);
})();


/* ============================================================
   BUNTIFY – SIZE ARROWS AROUND THE PREVIEW
   Horizontal arrow + "3 cm" under the preview, vertical arrow + "1,3 cm" at its right edge.
   Own elements next to the theme's media-gallery; Zepto's elements are not touched.
   To change a size, edit SIZE_NOTES.
   ============================================================ */
(function () {
  "use strict";

  var SIZE_NOTES = {
    "16093135176067": { w: "3 cm", h: "1,3 cm" },   // Namensaufkleber Klassik
    "16379882635651": { w: "2,8 cm", h: "1,2 cm" }  // Altenheim
    ,"16177787339139": { w: "4 cm", h: "0,6 cm" }  // Stifteaufkleber
  };
  if (window.BZ_PID && !SIZE_NOTES[window.BZ_PID]) return; // product without size note

  function currentNote() {
    for (var id in SIZE_NOTES) {
      if (document.getElementById("pplr-" + id)) return SIZE_NOTES[id];
    }
    return null;
  }

  function addStyle() {
    if (document.getElementById("buntify-size-note-css")) return;
    var st = document.createElement("style");
    st.id = "buntify-size-note-css";
    st.textContent =
      ".buntify-size-note{position:relative;display:flex;align-items:center;justify-content:center;gap:8px;" +
      "margin:6px auto 14px;padding:0 12px;color:#6b6b6b;font-size:14px;line-height:1;white-space:nowrap}" +
      ".buntify-size-note__line{position:relative;flex:1 1 0;max-width:64px;height:1px;background:currentColor;opacity:.5}" +
      ".buntify-size-note__line::before,.buntify-size-note__line::after{content:'';position:absolute;top:50%;" +
      "width:6px;height:6px;border:0 solid currentColor}" +
      ".buntify-size-note__line--l::before{left:1px;border-left-width:1px;border-bottom-width:1px;transform:translateY(-50%) rotate(45deg)}" +
      ".buntify-size-note__line--r::before{right:1px;border-right-width:1px;border-top-width:1px;transform:translateY(-50%) rotate(45deg)}" +
      ".buntify-size-v{position:absolute;display:flex;align-items:center;gap:3px;color:#6b6b6b;font-size:14px;line-height:1;pointer-events:none}" +
      ".buntify-size-v__line{position:relative;align-self:stretch;width:1px;background:currentColor;opacity:.5}" +
      ".buntify-size-v__line::before,.buntify-size-v__line::after{content:'';position:absolute;left:50%;" +
      "width:6px;height:6px;border:0 solid currentColor}" +
      ".buntify-size-v__line::before{top:1px;border-left-width:1px;border-top-width:1px;transform:translateX(-50%) rotate(45deg)}" +
      ".buntify-size-v__line::after{bottom:1px;border-right-width:1px;border-bottom-width:1px;transform:translateX(-50%) rotate(45deg)}" +
      ".buntify-size-v__text{writing-mode:vertical-rl;transform:rotate(180deg);white-space:nowrap}" +
      "@media screen and (max-width:749px){.buntify-size-note{width:min(320px,calc(100vw - 24px))}}";
    document.head.appendChild(st);
  }

  function previewBox(gallery) {
    return gallery.querySelector("#pplr_canvas") ||
      gallery.querySelector(".pplr_preview_wrapper canvas") ||
      gallery.querySelector(".product-media.pplr") ||
      gallery;
  }

  function layout(note, gallery) {
    var v = note.querySelector(".buntify-size-v");
    if (!v) return;
    var box = previewBox(gallery).getBoundingClientRect();
    var nr = note.getBoundingClientRect();
    if (box.height < 20) { v.style.display = "none"; return; }
    v.style.display = "flex";
    v.style.height = Math.round(box.height) + "px";
    v.style.top = Math.round(box.top - nr.top) + "px";
    v.style.left = Math.round(box.right - nr.left + 4) + "px";
  }

  var ro = null, roTarget = null;

  function ensureNote() {
    var data = currentNote();
    var existing = document.querySelector(".buntify-size-note");
    if (!data) { if (existing) existing.remove(); return; }
    var gallery = document.querySelector("media-gallery");
    if (!gallery || !gallery.parentNode) return;
    var sig = data.w + "|" + data.h;
    if (!(existing && existing.previousElementSibling === gallery && existing.getAttribute("data-t") === sig)) {
      if (existing) existing.remove();
      addStyle();
      existing = document.createElement("div");
      existing.className = "buntify-size-note";
      existing.setAttribute("data-t", sig);
      existing.setAttribute("aria-label", "Größe " + data.w + " x " + data.h);
      existing.innerHTML =
        '<span class="buntify-size-note__line buntify-size-note__line--l"></span>' +
        "<span class=\"buntify-size-note__w\"></span>" +
        '<span class="buntify-size-note__line buntify-size-note__line--r"></span>' +
        '<span class="buntify-size-v"><span class="buntify-size-v__line"></span><span class="buntify-size-v__text"></span></span>';
      existing.querySelector(".buntify-size-note__w").textContent = data.w;
      existing.querySelector(".buntify-size-v__text").textContent = data.h;
      gallery.parentNode.insertBefore(existing, gallery.nextSibling);
    }
    layout(existing, gallery);
    if (window.ResizeObserver) {
      var target = previewBox(gallery);
      if (target !== roTarget) {          // observe only when the element changed (observe() fires once itself)
        if (!ro) ro = new ResizeObserver(function () { schedule(); });
        ro.disconnect();
        ro.observe(target);
        roTarget = target;
      }
    }
  }

  var pending = 0;
  function schedule() {
    if (pending) return;
    pending = window.setTimeout(function () { pending = 0; ensureNote(); }, 120);
  }

  ensureNote();
  window.addEventListener("load", ensureNote);
  window.addEventListener("resize", schedule);
  window.addEventListener("pageshow", schedule);
  /* Before: every DOM change anywhere (reviews, gallery, apps) re-measured the preview with
     getBoundingClientRect. Now only when the note is missing/misplaced or the preview area changed.
     Size changes are still caught by the ResizeObserver and the resize listener. */
  new MutationObserver(function (m) {
    var gallery = document.querySelector("media-gallery");
    var note = document.querySelector(".buntify-size-note");
    var inGallery = false;
    for (var i = 0; i < m.length; i++) {
      var t = m[i].target;
      if (t && t.closest && t.closest(".buntify-size-note")) return;
      if (gallery && t && (t === gallery || gallery.contains(t))) inGallery = true;
    }
    if (!gallery || !note || note.previousElementSibling !== gallery || inGallery) schedule();
  }).observe(document.body, { childList: true, subtree: true });
})();

})((function () {
  var Native = window.MutationObserver;
  if (!Native) return Native;
  function BzMutationObserver(callback) {
    var self = this, pending = [], scheduled = false, active = true;
    function flush() {
      scheduled = false;
      if (!active || !pending.length) { pending = []; return; }
      var recs = pending; pending = [];
      callback.call(self, recs, self);
    }
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      var done = false;
      var run = function () { if (done) return; done = true; flush(); };
      if (window.requestAnimationFrame) window.requestAnimationFrame(function () { window.setTimeout(run, 0); }); // after the paint, so INP does not include it
      window.setTimeout(run, 100); // background tabs pause requestAnimationFrame
    }
    this._native = new Native(function (recs) {
      if (!active) return;
      for (var i = 0; i < recs.length; i++) pending.push(recs[i]);
      schedule();
    });
    this._setActive = function (v) { active = v; if (!v) pending = []; };
    this._take = function () { var r = pending.concat(self._native.takeRecords()); pending = []; return r; };
  }
  BzMutationObserver.prototype.observe = function (target, options) { this._setActive(true); this._native.observe(target, options); };
  BzMutationObserver.prototype.disconnect = function () { this._native.disconnect(); this._setActive(false); };
  BzMutationObserver.prototype.takeRecords = function () { return this._take(); };
  return BzMutationObserver;
})());


/* ============================================================
   BUNTIFY – MOTIF-ONLY PATTERNS (Oct 2026)
   A pattern listed here is shown in "Muster" only while one of its motifs is selected,
   and is chosen automatically when the customer picks that motif.
   Leaving the motif while such a pattern is selected switches back to "kein-muster".
   "patterns" lists the accepted names of the pattern value in Zepto (first one found is used).
   ============================================================ */
(function () {
  "use strict";
  var RULES = [
    { patterns: ["Muster-Eiswelt", "Eiswelt"], motifs: ["Aquarell-Pinguin"] },
    { patterns: ["Muster-Regenbogenhimmel", "Regenbogenhimmel"], motifs: ["Aquarell-Einhorn"] },
    { patterns: ["Muster-Blumenwiese", "Blumenwiese"], motifs: ["Aquarell-Schmetterling"] },
    { patterns: ["Muster-Savanne", "Savanne"], motifs: ["Aquarell-Loewe", "Aquarell-Tiger"] }
  ];
  var PRODUCTS = ["16093135176067", "16382167712131"];
  if (window.BZ_PID && PRODUCTS.indexOf(window.BZ_PID) < 0) return;
  var NONE = "kein-muster";

  function norm(v) {
    return String(v || "").toLowerCase().normalize("NFKD").replace(/[\u0300-\u036f]/g, "").replace(/[\s_]+/g, "-").trim();
  }
  function wrap(r, cls) { return r.querySelector(".pplr-wrapper" + cls); }
  function motifWrap(r) { return wrap(r, ".pplr-_design-whlen"); }
  function patternWrap(r) { return wrap(r, ".pplr-muster-whlen"); }
  function selectedVal(w) {
    var s = w && w.querySelector(".pplr-swatch-element.selected, .pplr-swatch-element.active");
    return s ? s.getAttribute("data-val") : "";
  }
  function patternEl(r, val) {
    var w = patternWrap(r);
    if (!w) return null;
    var list = w.querySelectorAll(".pplr-swatch-element");
    for (var i = 0; i < list.length; i++) if (norm(list[i].getAttribute("data-val")) === norm(val)) return list[i];
    return null;
  }
  function ruleForMotif(m) {
    for (var i = 0; i < RULES.length; i++) if (RULES[i].motifs.some(function (x) { return norm(x) === norm(m); })) return RULES[i];
    return null;
  }
  function ruleForPattern(p) {
    for (var i = 0; i < RULES.length; i++) if (RULES[i].patterns.some(function (x) { return norm(x) === norm(p); })) return RULES[i];
    return null;
  }
  function rulePatternEl(r, rule) {
    for (var i = 0; i < rule.patterns.length; i++) { var el = patternEl(r, rule.patterns[i]); if (el) return el; }
    return null;
  }

  // Show each motif-only pattern only while one of its motifs is selected.
  function sync(r) {
    var motif = norm(selectedVal(motifWrap(r)));
    RULES.forEach(function (rule) {
      var el = rulePatternEl(r, rule);
      if (!el) return;
      var ok = rule.motifs.some(function (m) { return norm(m) === motif; });
      el.style.setProperty("display", ok ? "flex" : "none", "important");
    });
  }

  function whenMotifSelected(r, val, cb) {
    var t0 = Date.now();
    (function poll() {
      if (norm(selectedVal(motifWrap(r))) === norm(val) || Date.now() - t0 > 1500) return cb();
      setTimeout(poll, 30);
    })();
  }

  document.addEventListener("click", function (e) {
    var sw = e.target.closest && e.target.closest(".pplr-swatch-element");
    if (!sw) return;
    var r = null;
    for (var i = 0; i < PRODUCTS.length && !r; i++) {
      var root = document.getElementById("pplr-" + PRODUCTS[i]);
      if (root && root.contains(sw)) r = root;
    }
    if (!r) return;
    if (!motifWrap(r) || !motifWrap(r).contains(sw)) { setTimeout(function () { sync(r); }, 300); return; }

    var val = sw.getAttribute("data-val");
    var byCustomer = e.isTrusted; // "Unsere Lieblingsdesigns" clicks are programmatic and set their own pattern
    whenMotifSelected(r, val, function () {
      sync(r);
      if (!byCustomer) return;
      var rule = ruleForMotif(val);
      var current = selectedVal(patternWrap(r));
      if (rule) {
        var el = rulePatternEl(r, rule);
        if (el && !el.classList.contains("selected") && !el.classList.contains("active")) el.click();
      } else if (ruleForPattern(current)) {
        var none = patternEl(r, NONE);
        if (none) none.click();
      }
    });
  }, false);

  // Initial state (Zepto renders late): hide motif-only patterns until their motif is chosen.
  var tries = 0;
  (function init() {
    var done = false;
    PRODUCTS.forEach(function (id) {
      var r = document.getElementById("pplr-" + id);
      if (r && patternWrap(r) && motifWrap(r)) { sync(r); done = true; }
    });
    if (++tries < 60) setTimeout(init, done ? 1500 : 500); // keep in sync for a while after load
  })();
})();